import InputField from "components/ui-component/InputField";
import useOutsideClick from "hooks/useOutsideClick";
import {
  forwardRef,
  useCallback,
  SetStateAction,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { dateToString } from "utils/DateFormat";
import CalendarIcon from "../../icons/dashboard/Calendar";
import CustomCalender from "components/calender/CustomCalender";
import InputSelect from "components/ui-component/InputSelect";
import expiryDateValidation, {
  checkBankManualFormOrPlaid,
  checkNewPaymentDetails,
  checkOldPaymentDetails,
  findObjectByValue,
  formatCurrency,
  formatExpirationDate,
  getCardType,
  getGeneralDetailMarkers,
  getOperatingSystem,
  nomberOfTransactionList,
  numberOfTransactions,
  validateCard,
} from "utils/HelperFunctions";
import TabsComp from "components/ui-component/Tabs";
import InfoIcon from "../../icons/dashboard/InfoIcon";
import CustomTable1 from "components/ui-component/CustomeTable1";
import { PaypalIcon } from "icons/dashboard/paypal";
import { ApplePayIcon } from "icons/payments/ApplePayIcon";
import { GooglePayIcon } from "icons/payments/GooglePayIcon";
import { CashAppIcon } from "icons/dashboard/cashAppIcon";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  getIntent,
  getpaymentPermission,
  getPlaidLinkToken,
  getPlaidPaymentToken,
  storePayPalOrder,
} from "store/slices/paymentsSlice";
import { useUserData } from "store/slices/authSlice";
import { CardIcon } from "icons/payments/Card";
import { BankIconSm } from "icons/payments/BankIconSm";
import Stepper from "components/ui-component/Stepper";
import WireTransferIcon from "icons/payments/WireTransferIcon";
import { useLocation, useParams } from "react-router-dom";
import { decode } from "utils/HelperFunctions";
import CustomAmountInput from "components/ui-component/CustomAmountInput";
import { usePortalSettingsData } from "store/slices/dashboardSlice";
import {
  onSetFinalDisclosureLoading,
  onSetShowDisclosure,
  useShowFinalDisclosure,
} from "store/slices/commonSlice";
import CheckedIcon from "icons/dashboard/CheckedIcon";
import Button from "components/form/Button";
import { Elements } from "@stripe/react-stripe-js";
import CashAppForm from "components/paymentMethod/CashAppForm";
import { loadStripe } from "@stripe/stripe-js";
import {
  FormRef,
  PaymentGateway,
  PaymentMethodList,
  SettingsValue,
} from "types/payments";
import StripeBankForm from "components/paymentMethod/StripeBankForm";
import BankPaymentButton from "components/payments/BankPaymentButton";
import CardPaymentButton from "components/payments/CardPaymentButton";
import AmazonPayForm from "components/paymentMethod/AmazonPayForm";
import AmazonPay from "icons/dashboard/AmazonPay";
import { PlaidLinkError, usePlaidLink } from "react-plaid-link";
import PaymentComponent from "./UpdatePaymentComponent";
import { useMediaQuery } from "react-responsive";
import { PaymentMethodSelection } from "utils/updatePaymentPlanUtils";
import DisclosureFinal from "./DisclosureFinal";
import CustomTooltip from "components/ui-component/CustomTooltip";
import { useOldWalletData } from "store/slices/paymentMethodSlice";
import { RootState } from "store/store";
import StripeCardPaymentCheckoutForm from "components/paymentMethod/StripeCardPaymentCheckoutForm";
import { CardFormCheckType } from "types/common";
import {
  calculateAmountOutstanding,
  CalculateCustomPercentage,
} from "utils/amount/amountCalculate";
import {
  getScheduleEndDateLimit,
  getTransactionConvenienceFee,
} from "utils/updatePaymentPlanUtils";
import Skeleton from "react-loading-skeleton";
import { resolveStripePublishableKey } from "utils/stripePublishableKey";

const Tabs = [
  {
    name: "Daily",
    value: "daily",
  },
  {
    name: "Weekly",
    value: "weekly",
  },
  {
    name: "Bi-weekly",
    value: "biweekly",
  },
  {
    name: "Monthly",
    value: "monthly",
  },
  {
    name: "Bi-monthly",
    value: "bimonthly",
  },
  {
    name: "Quarterly",
    value: "quarterly",
  },
  {
    name: "Semi-annually",
    value: "biannually",
  },
  {
    name: "Annually",
    value: "annually",
  },
  {
    name: "Custom",
    value: "custom",
  },
];

const ScheduleAmountList = [
  {
    name: "Fixed",
    value: "fixed",
    isdisabled: true,
  },
  {
    name: "Auto",
    value: "auto",
    isdisabled: true,
  },
  {
    name: "Custom",
    value: "custom",
    isdisabled: true,
  },
];

const ScheduleAmountTabs = [
  {
    name: "Amount",
    value: "amount",
  },
  {
    name: "Percent",
    value: "percent",
  },
];

const DesktopStepMarker = ({
  step,
  currentStep,
  completedSteps,
  isLastStep = false,
  onClick,
}: {
  step: number;
  currentStep: number;
  completedSteps: any;
  isLastStep?: boolean;
  onClick?: (step: number) => void;
}) => {
  const isActive = currentStep === step;
  const isCompleted = completedSteps?.includes?.(step);

  return (
    <span className="lg:block hidden absolute left-[-68px] top-1/2 z-20 h-[40px] w-[40px] -translate-y-1/2">
      {isLastStep && (
        <span className="absolute left-1/2 top-[40px] z-20 h-[var(--shell-vh)] w-4 -translate-x-1/2 bg-white" />
      )}
      <button
        type="button"
        className={`relative z-30 flex rounded-full border-[1px] w-[40px] h-[40px] justify-center items-center ${
          isActive
            ? "bg-btnPrimaryActive text-white"
            : "bg-white text-txtPrimary"
        } ${isCompleted ? "cursor-pointer" : "cursor-default"}`}
        onClick={() => {
          if (isCompleted) onClick?.(step);
        }}
      >
        {isCompleted ? <CheckedIcon /> : <p>{step}</p>}
      </button>
    </span>
  );
};

interface UpdateSchedulePaymentProps {
  currentStep: number;
  completedSteps: [];
  setIsStartDate: (value: boolean) => void;
  data: any;
  isStartDate: boolean;
  setData: any;
  setIsApiCall: (value: boolean) => void;
  handleDebouncedChange: () => void;
  setDataPayment: any;
  dataPayment: any;
  addNewRow: (index: number) => void;
  removeRow: (index: number) => void;
  handleSave?: () => void;
  handleChange: any;
  isLoading: boolean;
  accountLeadData: any;
  setCurrentStep: (num: number) => void;
  setCompletedSteps: any;
  isDataLoading: boolean;
  isUpdatePlan?: boolean;
  makePayment?: boolean;
  handlePrev?: () => void;
  setSavedCardsEmail?: any;
  setShowPreview?: any;
  setTab?: any;
  setPaymentProcess?: any;
  handleGooglePay?: any;
  createPayPalIntent?: any;
  isGoogleLoading?: boolean;
  setIsAddNewCard?: any;
  isAddNewCard?: any;
  setIsConfirmButtonDisable?: any;
  isSelectedOffer?: boolean;
  handleApplePay?: any;
  setIsSelectStartDate: any;
  show?: boolean;
  isRetryPayment?: boolean;
  onUpdatePaymentPlan?: any;
  failedPayment?: any;
  setIsPreview?: any;
  values?: any;
  setValues?: any;
  isUpdateLoading?: any;
  setSelectedMethod: (value: string) => void;
  selectedMethod: string;
  setShowButtons: (val: boolean) => void;
  showButtons: boolean;
  planId: string;
  isDisabled: boolean;
  setIsDisabled: (val: boolean) => void;
  isUpdateRetryLoading: boolean;
  verifyStripeCardPayment: ({
    intent,
    email,
    error,
    orderId,
    updateMethod,
  }: {
    intent: string | null;
    email: string;
    error: string | null;
    orderId?: number;
    updateMethod: boolean;
  }) => Promise<void>;
  startDate: string;
  setStartDate: (date: string) => void;
  isEndDateError?: boolean;
  dateErrMsg?: string | null;
  setDateErrMsg?: (message: string | null) => void;
  hasPaymentMethodChanged: boolean;
  hasScheduleChanged: boolean;
  onPaymentMethodChange: (selection: PaymentMethodSelection) => void;
  handlePlaidBankPayment?: (
    val: any,
    isCCTokenAvailable: boolean
  ) => Promise<void>;
}

type UpdateScheduleTableProps = {
  currentStep: number;
  isRetryPayment: boolean;
  data: any;
  setIsStartDate: (val: boolean) => void;
  isStartDate: boolean;
  setIsSelectStartDate: (val: boolean) => void;
  setIsApiCall: (val: boolean) => void;
  setData: any;
  handleDebouncedChange: () => void;
  setAmtErr?: any;
  amtErr?: any;
  addNewRow: (index: number) => void;
  removeRow: (index: number) => void;
  handleSave?: () => void;
  handleChange: any;
  isLoading: boolean;
  isSelectedOffer?: boolean;
  makePayment?: boolean;
  startDate: string;
  setStartDate: (date: string) => void;
  desktopStepMarker?: React.ReactNode;
  isEndDateError?: boolean;
  dateErrMsg?: string | null;
  setDateErrMsg?: (message: string | null) => void;
};

const UpdateSchedulePayment = ({
  setSelectedMethod,
  selectedMethod,
  currentStep,
  completedSteps,
  setIsStartDate,
  data,
  isStartDate,
  setData,
  setIsApiCall,
  handleDebouncedChange,
  setDataPayment,
  dataPayment,
  addNewRow,
  removeRow,
  handleChange,
  handleSave,
  isLoading,
  accountLeadData,
  setCurrentStep,
  setCompletedSteps,
  isDataLoading,
  handlePrev = () => {},
  setSavedCardsEmail,
  setShowPreview,
  handleGooglePay,
  createPayPalIntent,
  isGoogleLoading = false,
  setIsAddNewCard = () => {},
  isAddNewCard = false,
  handleApplePay = () => {},
  setIsSelectStartDate,
  show = false,
  isRetryPayment = false,
  onUpdatePaymentPlan = () => {},
  failedPayment = 0,
  values,
  setValues,
  isUpdateLoading,
  setShowButtons,
  showButtons,
  planId,
  isDisabled,
  startDate,
  setStartDate,
  isEndDateError = false,
  dateErrMsg = null,
  setDateErrMsg = () => {},
  hasPaymentMethodChanged,
  hasScheduleChanged,
  onPaymentMethodChange,
  setIsDisabled,
  isUpdateRetryLoading,
  verifyStripeCardPayment,
  handlePlaidBankPayment = async (
    val: any,
    isCCTokenAvailable: boolean
  ): Promise<void> => {
    return Promise.resolve();
  },
}: UpdateSchedulePaymentProps) => {
  const [paymentMethodList, setPaymentMethodList] =
    useState<PaymentMethodList[]>();
  const location = useLocation();
  const walletList = useOldWalletData();
  const [isSecretLoading, setIsSecretLoading] = useState<boolean>(false);
  const [clientSecret, setClientSecret] = useState<any>("");
  const [showUpdateButtons, setShowUpdateButtons] = useState<boolean>(false);
  const [bankSecret, setBankSecret] = useState<any>("");
  const searchParams = new URLSearchParams(location.search);
  const showFinalDisclosure = useShowFinalDisclosure();
  const isLessThan769 = useMediaQuery({ query: "(max-width: 769px)" });
  const { paymentPermission, companyDetails } = useAppSelector(
    (state) => state.payment
  );
  const selectedStripeKey = useMemo(() => {
    switch (selectedMethod) {
      case "Cash App Pay":
        return resolveStripePublishableKey(paymentPermission, "CAPP");
      case "Amazon Pay":
        return resolveStripePublishableKey(paymentPermission, "AMZP");
      case "Card":
        return resolveStripePublishableKey(paymentPermission, "CC");
      case "Bank":
        return resolveStripePublishableKey(paymentPermission, "ACH");
      default:
        return null;
    }
  }, [paymentPermission, selectedMethod]);
  const stripePromise = useMemo(
    () => (selectedStripeKey ? loadStripe(selectedStripeKey) : null),
    [selectedStripeKey]
  );
  const [linkToken, setLinkToken] = useState<string | null>(null);
  const [isLinkTokenLoading, setIsLinkTokenLoading] = useState<boolean>(false);
  const cashAppRef = useRef<FormRef>(null);
  const bankRef = useRef<FormRef>(null);
  const cardRef = useRef<FormRef>(null);
  const amazonRef = useRef<FormRef>(null);
  const cashAppRef1 = useRef<FormRef>(null);
  const bankRef1 = useRef<FormRef>(null);
  const cardRef1 = useRef<FormRef>(null);
  const amazonRef1 = useRef<FormRef>(null);
  const desktopFlowRef = useRef<HTMLDivElement>(null);
  const [desktopConnectors, setDesktopConnectors] = useState<
    { top: number; height: number; fromStep: number }[]
  >([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [email, setEmail] = useState<string>("");
  const [cardNumber, setcardNumber] = useState<string>("");
  const [iconType, setIconType] = useState<string>("");
  const [selectedState, setSelectedState] = useState<any>(undefined);
  const [formCheck, setFormCheck] = useState<CardFormCheckType>({
    card: false,
    expiry: false,
    cvv: false,
  });
  const [formEmptyCheck, setFormEmptyCheck] = useState<CardFormCheckType>({
    card: true,
    expiry: true,
    cvv: true,
  });
  const [isDateErr, setIsDateErr] = useState<boolean>(false);
  const [bankName, setBankName] = useState<any>("");
  const [bank, setBank] = useState<any>("");
  const [errMsg, setErrMsg] = useState<string | undefined>(undefined);
  const [isRingLoading, setIsRingLoading] = useState<boolean>(false);
  const [numberNotmatchedError, setnumberNotmatchedError] =
    useState<boolean>(false);
  const [isErr, setIsErr] = useState(-1);
  const [cardErrMsg, setCardErrMsg] = useState("");
  const [isRetry, setIsRetry] = useState<boolean>(false);
  const [isManualForm, setIsManualForm] = useState<boolean>(true);

  const { clusterId: cluster_id } = useParams();
  const clusterId = decode(cluster_id || "", true);
  const userData = useUserData();
  const dispatch = useAppDispatch();
  const [amtErr, setAmtErr] = useState<string | null>(null);
  const portalSettings = usePortalSettingsData();
  const defaultPaymentMethodList = [
    {
      name: "Card",
      icon: <CardIcon />,
    },
    {
      name: "Bank",
      icon: <BankIconSm />,
    },
  ];

  useLayoutEffect(() => {
    if (isLessThan769 || showFinalDisclosure) {
      setDesktopConnectors([]);
      return;
    }

    const measureConnector = () => {
      const container = desktopFlowRef.current;
      if (!container) return;

      const headings = Array.from(
        container.querySelectorAll<HTMLElement>("[data-update-step-heading]")
      ).filter((heading) => {
        const step = Number(heading.dataset.updateStepHeading);
        return step > 0 && step <= (isRetryPayment ? 3 : 2);
      });

      if (headings.length < (isRetryPayment ? 3 : 2)) return;

      const containerTop = container.getBoundingClientRect().top;
      const centers = headings.map((heading) => {
        const rect = heading.getBoundingClientRect();
        return rect.top - containerTop + rect.height / 2;
      });

      const nextConnectors = centers.slice(0, -1).map((center, index) => ({
        top: center + 20,
        height: Math.max(centers[index + 1] - center, 0),
        fromStep: index + 1,
      }));

      setDesktopConnectors((prev) => {
        const hasSameConnectors =
          prev.length === nextConnectors.length &&
          prev.every(
            (connector, index) =>
              connector.fromStep === nextConnectors[index].fromStep &&
              Math.abs(connector.top - nextConnectors[index].top) < 1 &&
              Math.abs(connector.height - nextConnectors[index].height) < 1
          );

        return hasSameConnectors ? prev : nextConnectors;
      });
    };

    measureConnector();

    const resizeObserver =
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(measureConnector)
        : null;

    [
      desktopFlowRef.current,
      ...Array.from(
        desktopFlowRef.current?.querySelectorAll(
          "[data-update-step-heading]"
        ) || []
      ),
      // The collapsible sections between the headings animate their height;
      // observing them re-measures once the expansion settles, otherwise the
      // connector keeps the stale mid-transition length.
      ...Array.from(
        desktopFlowRef.current?.querySelectorAll(
          ".answerSection, .answerSection1"
        ) || []
      ),
    ].forEach((element) => {
      if (element) resizeObserver?.observe(element);
    });

    const flowContainer = desktopFlowRef.current;
    flowContainer?.addEventListener("transitionend", measureConnector);
    window.addEventListener("resize", measureConnector);

    return () => {
      resizeObserver?.disconnect();
      flowContainer?.removeEventListener("transitionend", measureConnector);
      window.removeEventListener("resize", measureConnector);
    };
  }, [currentStep, isLessThan769, isRetryPayment, showFinalDisclosure]);

  useEffect(() => {
    if (hasScheduleChanged && !hasPaymentMethodChanged) {
      setShowButtons(true);
      setShowUpdateButtons(true);
      return;
    }

    if (isAddNewCard) {
      setShowButtons(true);
      setShowUpdateButtons(true);
    } else {
      if (selectedMethod === "Card") {
        if (
          paymentPermission?.cc_gateway_name?.name === PaymentGateway.STRIPE
        ) {
          setShowButtons(false);
          setShowUpdateButtons(false);
        } else {
          setShowButtons(true);
          setShowUpdateButtons(true);
        }
      } else if (selectedMethod === "Bank") {
        let check = checkBankManualFormOrPlaid({
          manual_ach: portalSettings?.manual_ach,
          validate_bank_account: portalSettings?.validate_bank_account,
          isManualForm,
        });
        if (
          paymentPermission?.ach_gateway_name?.name === PaymentGateway.STRIPE ||
          check
        ) {
          setShowButtons(false);
          setShowUpdateButtons(false);
        } else {
          setShowButtons(true);
          setShowUpdateButtons(true);
        }
      } else if (selectedMethod === "Wire") {
        setShowButtons(true);
        setShowUpdateButtons(true);
      } else if (selectedMethod === "PayPal") {
        setShowButtons(false);
        setShowUpdateButtons(false);
      } else if (selectedMethod === "Cash App Pay") {
        setShowButtons(false);
        setShowUpdateButtons(false);
      } else if (selectedMethod === "Amazon Pay") {
        setShowButtons(false);
        setShowUpdateButtons(false);
      }
    }
  }, [
    selectedMethod,
    isAddNewCard,
    paymentPermission,
    portalSettings,
    isManualForm,
    show,
    hasPaymentMethodChanged,
    hasScheduleChanged,
  ]);

  const getPaymentMethodPermission = async () => {
    try {
      let payload = {
        accountid: userData?.data?.accountData?.accountid,
        clusterid: clusterId,
        lead_id: accountLeadData?.lead_id,
      };
      await dispatch(getpaymentPermission(payload));
    } catch (error) {
      console.log("getPaymentMethodPermission error =====", error);
    }
  };

  useEffect(() => {
    if (
      paymentPermission &&
      Object.keys(paymentPermission).length === 0 &&
      show
    ) {
      getPaymentMethodPermission();
    }
  }, [show]);

  useEffect(() => {
    if (isRetryPayment) {
      if (isAddNewCard) {
        let response = checkOldPaymentDetails({ dataPayment });
        setIsDisabled(response);
      } else {
        let check = checkBankManualFormOrPlaid({
          manual_ach: portalSettings?.manual_ach,
          validate_bank_account: portalSettings?.validate_bank_account,
          isManualForm,
        });
        if (selectedMethod === "Card") {
          let response = checkNewPaymentDetails({
            values,
            cc_billing_address: portalSettings?.cc_billing_address,
            cc_billing_addr_mandatory:
              portalSettings?.cc_billing_addr_mandatory,
            selectedMethod: "Card",
            email,
            isErr,
            errMsg,
          });
          setIsDisabled(response);
        } else if (
          selectedMethod === "Bank" &&
          paymentPermission?.ach_gateway_name?.name !== PaymentGateway?.STRIPE
        ) {
          if (check && !isSecretLoading) {
            setIsDisabled(false);
          } else {
            let response = checkNewPaymentDetails({
              values,
              cc_billing_address: portalSettings?.cc_billing_address,
              cc_billing_addr_mandatory:
                portalSettings?.cc_billing_addr_mandatory,
              selectedMethod: "Bank",
              email,
              isErr,
              errMsg,
            });
            setIsDisabled(response);
          }
        } else if (selectedMethod === "PayPal" || selectedMethod === "Wire") {
          setIsDisabled(false);
        } else {
          setIsDisabled(isSecretLoading);
        }
      }
    } else {
      if (isAddNewCard) {
        let response = checkOldPaymentDetails({ dataPayment });
        setIsDisabled(response);
      } else {
        let response = checkNewPaymentDetails({
          values,
          cc_billing_address: portalSettings?.cc_billing_address,
          cc_billing_addr_mandatory: portalSettings?.cc_billing_addr_mandatory,
          selectedMethod,
          email,
          isErr,
          errMsg,
        });
        setIsDisabled(response);
      }
    }
  }, [
    selectedMethod,
    values,
    email,
    isAddNewCard,
    dataPayment,
    isErr,
    errMsg,
    isSecretLoading,
    isRetryPayment,
  ]);

  useEffect(() => {
    if (paymentPermission) {
      let methodList = [];

      if (paymentPermission.cc_ext_availability === SettingsValue.YES) {
        methodList.push({
          name: "Card",
          icon: <CardIcon />,
        });
      }

      if (paymentPermission.ach_ext_availability === SettingsValue.YES) {
        methodList.push({
          name: "Bank",
          icon: <BankIconSm />,
        });
      }

      if (
        paymentPermission.pp_ext_availability === SettingsValue.YES &&
        paymentPermission?.pp_gateway_name?.name !== PaymentGateway.STAX
      ) {
        methodList.push({
          name: "PayPal",
          icon: <PaypalIcon />,
        });
      }

      if (paymentPermission.capp_ext_availability === SettingsValue.YES) {
        methodList.push({
          name: "Cash App Pay",
          icon: <CashAppIcon />,
        });
      }
      if (paymentPermission.amzp_ext_availability === SettingsValue.YES) {
        methodList.push({
          name: "Amazon Pay",
          icon: <AmazonPay />,
        });
      }

      if (paymentPermission.cc_ext_availability === SettingsValue.NO) {
        setSelectedMethod(methodList?.[0]?.name);
      }

      setPaymentMethodList(methodList);
    } else {
      setPaymentMethodList(defaultPaymentMethodList);
    }
  }, [paymentPermission]);

  const handleOnClick = (step: number) => {
    if (step < currentStep) {
      setCurrentStep(step);
      setCompletedSteps(Array.from({ length: step }, (_, i) => i));
    } else {
      return;
    }
  };

  const getSecret = async (payment_method_types: string) => {
    let clusterid = clusterId
      ? clusterId
      : userData?.data?.accountData?.clusterid;
    setIsSecretLoading(true);
    try {
      let payload = {
        name:
          (userData?.data?.accountData?.first_name || "") +
          (userData?.data?.accountData?.last_name || ""),
        email: userData?.data?.accountData?.email,
        phone_number: userData?.data?.accountData?.phone,
        description: "Online Payment",
        payment_note: "Custom Plan",
        currency: "usd",
        payment_method_types,
        isRecurring: true,
        stripe_fin: payment_method_types === "us_bank_account" ? "Y" : "N",
        accountid: userData?.data?.accountData?.accountid,
        cluster_id: clusterid,
        custom_conv: "on",
      };
      let res: any = await dispatch(getIntent(payload));
      if (res?.payload?.body?.success) {
        if (
          payment_method_types === "cashapp" ||
          payment_method_types === "amazon_pay"
        ) {
          dispatch(
            storePayPalOrder({
              data: data,
              dataPayment: dataPayment,
              clusterid: clusterid,
              updateFlags: {
                updateMethod: hasPaymentMethodChanged,
                updateSchedule: hasScheduleChanged,
              },
            })
          );
          setClientSecret(res?.payload?.body?.data?.client_secret);
        } else {
          setBankSecret(res?.payload?.body?.data?.client_secret);
        }
      }
      setIsSecretLoading(false);
    } catch (err) {
      console.log("err =====", err);
      setIsSecretLoading(false);
    }
  };

  const getPlaidToken = async () => {
    setIsLinkTokenLoading(true);
    let clusterid = clusterId
      ? clusterId
      : userData?.data?.accountData?.clusterid;
    try {
      let payload = {
        client_name:
          (companyDetails?.name || companyDetails?.company_name) ??
          "Palm Labs LLC",
        first_name: userData?.data?.accountData?.first_name,
        last_name: userData?.data?.accountData?.last_name?.trim(),
        email: userData?.data?.accountData?.email || email,
        clusterid: clusterid,
        slug: cluster_id || "",
      };
      let res: any = await dispatch(getPlaidLinkToken(payload)).unwrap();
      if (res?.body?.success) {
        setLinkToken(res?.body?.data?.link_token || null);
      }
      setIsLinkTokenLoading(false);
    } catch (error) {
      console.log("getPlaidToken error =====", error);
      setIsLinkTokenLoading(false);
    }
  };

  useEffect(() => {
    if (
      selectedMethod === "Cash App Pay" &&
      !searchParams.has("payment_intent") &&
      !searchParams.has("setup_intent") &&
      isRetryPayment
    ) {
      getSecret("cashapp");
    }

    if (
      selectedMethod === "Amazon Pay" &&
      !searchParams.has("payment_intent") &&
      !searchParams.has("setup_intent") &&
      isRetryPayment
    ) {
      getSecret("amazon_pay");
    }

    if (
      selectedMethod === "Bank" &&
      !searchParams.has("payment_intent") &&
      !searchParams.has("setup_intent") &&
      paymentPermission?.ach_gateway_name?.name === PaymentGateway.STRIPE &&
      !bankSecret &&
      isRetryPayment
    ) {
      getSecret("us_bank_account");
    }

    let check = checkBankManualFormOrPlaid({
      manual_ach: portalSettings?.manual_ach,
      validate_bank_account: portalSettings?.validate_bank_account,
      isManualForm,
    });

    if (
      selectedMethod === "Bank" &&
      paymentPermission?.ach_gateway_name?.name !== PaymentGateway.STRIPE &&
      check &&
      isRetryPayment
    ) {
      getPlaidToken();
    }
  }, [selectedMethod, isManualForm, portalSettings, isRetryPayment]);

  const bankFormOptions = {
    clientSecret: bankSecret,
    appearance: {
      variables: {
        fontFamily: "DM Sans, sans-serif",
        colorDanger: "#ff0000",
        fontSizeSm: "12px",
        fontSizeXs: "12px",
        colorText: "#19224c",
        colorTextSecondary: "#19224c",
        colorPrimary: "#1678f2",
        colorBackgroundDeemphasize10: "#dfe4ec",
        borderRadius: "6px",
      },
      rules: {
        ".Label": {
          color: "#8c90a5",
          fontWeight: "700",
          fontSize: "12px",
          textTransform: "uppercase",
        },
        ".Input::placeholder": {
          fontWeight: "400",
          fontSize: "12px",
          color: "#8c90a5",
        },
        ".Input": {
          border: "1px solid #dfe4ec",
          fontWeight: "400",
          fontSize: "12px",
          color: "#8c90a5",
        },
        ".Error": {
          fontSize: "12px",
          fontWeight: "400",
        },
        ".PickerItem": {
          border: "1px solid #dfe4ec",
          borderRadius: "6px",
        },
      },
    },
  };

  const handleChangeCard = (e: any, name: string) => {
    if (name === "x_card_num") {
      let icon = getCardType(e.target.value) || iconType;
      setIconType(icon);
      if (icon === "amex") {
        if (e.target.value.length < 18) {
          const cardNumber = e.target.value.replace(/\s/g, "");
          const formattedCardNumber = cardNumber
            .replace(/\D/g, "")
            .replace(/(\d{4})(\d{6})(\d{5})/, "$1 $2 $3");
          setcardNumber(formattedCardNumber);
          setValues({ ...values, [name]: e.target.value });
        }
      } else {
        if (e.target.value.length < 20) {
          const cardNumber = e.target.value.replace(/\s/g, "");
          const formattedCardNumber = cardNumber
            .replace(/\D/g, "")
            .replace(/(\d{4})(?=\d)/g, "$1 ");
          setcardNumber(formattedCardNumber);
          setValues({ ...values, [name]: e.target.value });
        }
      }
    } else if (name === "x_card_code") {
      if (iconType === "amex") {
        if (e.target.value.length < 5) {
          setValues({ ...values, [name]: e.target.value });
        }
      } else {
        if (e.target.value.length < 4) {
          setValues({ ...values, [name]: e.target.value });
        }
      }
    } else if (name === "x_exp_date") {
      const inputValue = e.target.value;
      setIsDateErr(false);
      if (inputValue?.length < 6) {
        const isValidDate: any = expiryDateValidation(inputValue);
        const formattedDate = formatExpirationDate(inputValue);
        setValues({ ...values, [name]: formattedDate });
        !isValidDate?.isValid && inputValue?.length === 5 && setIsDateErr(true);
      }
    } else if (name === "x_country") {
      setValues({ ...values, [name]: e?.value });
    } else if (name === "x_state") {
      setValues({ ...values, [name]: e?.name });
    } else {
      setValues({ ...values, [name]: e.target.value });
    }
  };

  const getAmount = () => {
    let amount = 0;
    // if (data?.paymentPlan?.transaction_type === "amount") {
    data?.paymentPlan?.transactions?.forEach((transaction: any) => {
      if (
        moment(
          transaction?.date ||
            transaction?.payment_date ||
            transaction?.billing_date
        ).isSameOrAfter(moment(), "day")
      ) {
        amount = data?.paymentPlan?.amount || 0;
      }
    });

    if (isRetryPayment) {
      amount += failedPayment || 0;
    }
    return Number(amount) || 0;
  };

  const generalMarkers = getGeneralDetailMarkers({
    conFee: 0,
    paymentAmount: "0",
  });

  const handleAccept = async () => {
    await dispatch(onSetFinalDisclosureLoading(true));
    try {
      if (isAddNewCard) {
        await onUpdatePaymentPlan(isRetry);
      } else {
        switch (selectedMethod) {
          case "Card":
            if (
              paymentPermission?.cc_gateway_name?.name === PaymentGateway.STRIPE
            ) {
              if (isRetry && cardRef1.current) {
                await cardRef1.current.callHandleClick();
              } else if (cardRef.current) {
                await cardRef.current.callHandleClick();
              } else {
                await dispatch(onSetFinalDisclosureLoading(false));
              }
            } else {
              await onUpdatePaymentPlan(isRetry);
            }
            break;
          case "Amazon Pay":
            if (isRetry && amazonRef1.current) {
              await amazonRef1.current.callHandleClick();
            } else if (amazonRef.current) {
              await amazonRef.current.callHandleClick();
            } else {
              await onUpdatePaymentPlan(isRetry);
            }
            break;
          case "Bank":
            let check = checkBankManualFormOrPlaid({
              manual_ach: portalSettings?.manual_ach,
              validate_bank_account: portalSettings?.validate_bank_account,
              isManualForm,
            });
            if (
              paymentPermission?.ach_gateway_name?.name ===
                PaymentGateway.STRIPE ||
              check
            ) {
              if (isRetry && bankRef1.current) {
                await bankRef1.current.callHandleClick();
              } else if (bankRef.current) {
                await bankRef.current.callHandleClick();
              } else {
                await dispatch(onSetFinalDisclosureLoading(false));
              }
            } else {
              await onUpdatePaymentPlan(isRetry);
            }
            break;
          case "Cash App Pay":
            if (isRetry && cashAppRef1.current) {
              await cashAppRef1.current.callHandleClick();
            } else if (cashAppRef.current) {
              await cashAppRef.current.callHandleClick();
            } else {
              await onUpdatePaymentPlan(isRetry);
            }
            break;
          case "Wire":
            await onUpdatePaymentPlan(isRetry);
            break;
          case "PayPal":
            await onUpdatePaymentPlan(isRetry);
            break;
          case "Google Pay":
            await onUpdatePaymentPlan(isRetry);
            break;
          default:
            console.log("selectedMethod =====", selectedMethod);
        }
      }
    } catch (error) {
      console.log("error =====", error);
    }
  };

  const handleStripeCardPayment = async ({
    intent = "",
    email = "",
    error = null,
    orderId,
  }: {
    intent?: string | null;
    email?: string;
    error?: string | null;
    orderId?: number;
  }) => {
    await verifyStripeCardPayment({
      intent,
      email,
      error,
      orderId,
      updateMethod: true,
    });
  };

  return (
    <>
      <div
        ref={desktopFlowRef}
        className=" gap-7 pb-[76px] h-full lg:flex hidden"
      >
        {showFinalDisclosure ? (
          <></>
        ) : (
          <div className="w-[40px] shrink-0 relative">
            {desktopConnectors.map((connector) => {
              if (connector.height <= 0) return null;

              const shouldShowActiveGuide = currentStep === connector.fromStep;
              const shouldShowCompletedConnector =
                currentStep > connector.fromStep;

              if (!shouldShowActiveGuide && !shouldShowCompletedConnector) {
                return null;
              }

              return (
                <div
                  key={connector.fromStep}
                  className="absolute left-1/2 w-[1px] -translate-x-1/2"
                  style={{
                    top: connector.top,
                    height: connector.height,
                  }}
                >
                  {shouldShowActiveGuide ? (
                    <div
                      className="h-full w-[1px]"
                      style={{
                        backgroundImage:
                          "repeating-linear-gradient(to bottom, var(--color-btn-primary-active) 0 4px, transparent 4px 7px)",
                      }}
                    />
                  ) : (
                    <div className="h-full w-[1px] bg-btnPrimaryActive" />
                  )}
                </div>
              );
            })}
          </div>
        )}
        <div className="w-full">
          {/* SCHDULE PAYMENT  */}
          {showFinalDisclosure ? (
            <></>
          ) : (
            <UpdateScheduleTable
              currentStep={currentStep}
              addNewRow={addNewRow}
              isRetryPayment={isRetryPayment}
              data={data}
              setData={setData}
              setIsStartDate={setIsStartDate}
              isStartDate={isStartDate}
              setIsApiCall={setIsApiCall}
              handleDebouncedChange={handleDebouncedChange}
              setAmtErr={setAmtErr}
              amtErr={amtErr}
              removeRow={removeRow}
              handleSave={handleSave}
              handleChange={handleChange}
              isLoading={isLoading}
              setIsSelectStartDate={setIsSelectStartDate}
              startDate={startDate}
              setStartDate={setStartDate}
              desktopStepMarker={
                <DesktopStepMarker
                  step={1}
                  currentStep={currentStep}
                  completedSteps={completedSteps}
                  onClick={handleOnClick}
                />
              }
              isEndDateError={isEndDateError}
              dateErrMsg={dateErrMsg}
              setDateErrMsg={setDateErrMsg}
            />
          )}

          {/* PAYMENT METHOD */}
          {isRetryPayment ? (
            bankSecret &&
            selectedMethod === "Bank" &&
            paymentPermission?.ach_gateway_name.name ===
              PaymentGateway.STRIPE &&
            !isAddNewCard ? (
              <>
                <div className={showFinalDisclosure ? "hidden none" : ""}>
                  <Elements stripe={stripePromise} options={bankFormOptions}>
                    <PaymentComponent
                      desktopStepMarker={
                        <DesktopStepMarker
                          step={2}
                          currentStep={currentStep}
                          completedSteps={completedSteps}
                          isLastStep={!isRetryPayment}
                          onClick={handleOnClick}
                        />
                      }
                      setCompletedSteps={setCompletedSteps}
                      completedSteps={completedSteps}
                      currentStep={currentStep}
                      isRetryPayment={isRetryPayment}
                      isAddNewCard={isAddNewCard}
                      setIsAddNewCard={setIsAddNewCard}
                      setDataPayment={setDataPayment}
                      dataPayment={dataPayment}
                      setCurrentStep={setCurrentStep}
                      walletList={walletList}
                      isDataLoading={isDataLoading}
                      setSavedCardsEmail={setSavedCardsEmail}
                      setShowPreview={setShowPreview}
                      paymentMethodList={paymentMethodList}
                      setSelectedMethod={setSelectedMethod}
                      onPaymentMethodChange={onPaymentMethodChange}
                      cardNumber={cardNumber}
                      setIconType={setIconType}
                      setValues={setValues}
                      values={values}
                      setIsRingLoading={setIsRingLoading}
                      setBankName={setBankName}
                      setBank={setBank}
                      setErrMsg={setErrMsg}
                      iconType={iconType}
                      setcardNumber={setcardNumber}
                      setIsDateErr={setIsDateErr}
                      setnumberNotmatchedError={setnumberNotmatchedError}
                      setSelectedState={setSelectedState}
                      selectedMethod={selectedMethod}
                      selectedState={selectedState}
                      isDateErr={isDateErr}
                      numberNotmatchedError={numberNotmatchedError}
                      bankName={bankName}
                      isRingLoading={isRingLoading}
                      email={email}
                      setEmail={setEmail}
                      data={data}
                      setIsErr={setIsErr}
                      setCardErrMsg={setCardErrMsg}
                      cardErrMsg={cardErrMsg}
                      isErr={isErr}
                      handleGooglePay={handleGooglePay}
                      handlePrev={handlePrev}
                      createPayPalIntent={createPayPalIntent}
                      isGoogleLoading={isGoogleLoading}
                      handleApplePay={handleApplePay}
                      setAmtErr={setAmtErr}
                      amtErr={amtErr}
                      isManualForm={isManualForm}
                      setIsManualForm={setIsManualForm}
                      amount={getAmount()}
                      handlePlaidBankPayment={handlePlaidBankPayment}
                      queryParams={`&plansDrawer=true&planId=${planId}&amount=${getAmount()}&checked=false&isRetry=true&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}`}
                      isDisabled={isDisabled}
                      isSecretLoading={isSecretLoading}
                      BankOrCardComp={
                        <div className="pt-10">
                          <StripeBankForm
                            email={email}
                            setEmail={setEmail}
                            isSecretLoading={isLoading}
                            isRetry={true}
                            setIsDisable={setIsDisabled}
                          />
                        </div>
                      }
                    />
                    <RetryPaymentStep
                      desktopStepMarker={
                        <DesktopStepMarker
                          step={3}
                          currentStep={currentStep}
                          completedSteps={completedSteps}
                          isLastStep
                          onClick={handleOnClick}
                        />
                      }
                      isRetryPayment={isRetryPayment}
                      currentStep={currentStep}
                      failedPayment={failedPayment}
                      isUpdateLoading={isUpdateLoading}
                      showButtons={false}
                      isUpdateRetryLoading={isUpdateRetryLoading}
                      buttonComp={
                        <div className="w-full flex justify-between gap-4 ">
                          <BankPaymentButton
                            buttonText="Update and retry"
                            className="w-full"
                            isLoading={isUpdateRetryLoading}
                            isRecurring={true}
                            ref={bankRef1}
                            handleClick={() => {
                              setIsRetry(true);
                            }}
                            stripeBankURL={`${
                              window.location.href
                            }?plansDrawer=true&amount=${getAmount()}&method=bank&isRetry=true&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}&planId=${planId}&checked=false`}
                          />
                          <BankPaymentButton
                            buttonText="Update Only"
                            className="w-full"
                            isLoading={isUpdateLoading}
                            isRecurring={true}
                            ref={bankRef}
                            handleClick={() => {
                              setIsRetry(false);
                            }}
                            stripeBankURL={`${
                              window.location.href
                            }?plansDrawer=true&amount=${getAmount()}&method=bank&isRetry=false&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}&planId=${planId}&checked=false`}
                          />
                        </div>
                      }
                    />
                  </Elements>
                </div>
                {showFinalDisclosure && (
                  <DisclosureFinal
                    isOpen={showFinalDisclosure}
                    generalMarkers={generalMarkers}
                    handleAccept={handleAccept}
                    isDrawer={true}
                  />
                )}
              </>
            ) : selectedMethod === "Card" &&
              paymentPermission?.cc_gateway_name?.name ===
                PaymentGateway.STRIPE &&
              !isAddNewCard ? (
              <>
                <div className={showFinalDisclosure ? "hidden none" : ""}>
                  <Elements stripe={stripePromise}>
                    <PaymentComponent
                      desktopStepMarker={
                        <DesktopStepMarker
                          step={2}
                          currentStep={currentStep}
                          completedSteps={completedSteps}
                          isLastStep={!isRetryPayment}
                          onClick={handleOnClick}
                        />
                      }
                      currentStep={currentStep}
                      completedSteps={completedSteps}
                      setCompletedSteps={setCompletedSteps}
                      isRetryPayment={isRetryPayment}
                      isAddNewCard={isAddNewCard}
                      setIsAddNewCard={setIsAddNewCard}
                      setDataPayment={setDataPayment}
                      dataPayment={dataPayment}
                      setCurrentStep={setCurrentStep}
                      walletList={walletList}
                      isDataLoading={isDataLoading}
                      setSavedCardsEmail={setSavedCardsEmail}
                      setShowPreview={setShowPreview}
                      paymentMethodList={paymentMethodList}
                      setSelectedMethod={setSelectedMethod}
                      onPaymentMethodChange={onPaymentMethodChange}
                      cardNumber={cardNumber}
                      setIconType={setIconType}
                      setValues={setValues}
                      values={values}
                      setIsRingLoading={setIsRingLoading}
                      setBankName={setBankName}
                      setBank={setBank}
                      setErrMsg={setErrMsg}
                      iconType={iconType}
                      setcardNumber={setcardNumber}
                      setIsDateErr={setIsDateErr}
                      setnumberNotmatchedError={setnumberNotmatchedError}
                      setSelectedState={setSelectedState}
                      selectedMethod={selectedMethod}
                      selectedState={selectedState}
                      isDateErr={isDateErr}
                      numberNotmatchedError={numberNotmatchedError}
                      bankName={bankName}
                      isRingLoading={isRingLoading}
                      email={email}
                      setEmail={setEmail}
                      data={data}
                      setIsErr={setIsErr}
                      setCardErrMsg={setCardErrMsg}
                      cardErrMsg={cardErrMsg}
                      isErr={isErr}
                      handleGooglePay={handleGooglePay}
                      handlePrev={handlePrev}
                      createPayPalIntent={createPayPalIntent}
                      isGoogleLoading={isGoogleLoading}
                      handleApplePay={handleApplePay}
                      setAmtErr={setAmtErr}
                      amtErr={amtErr}
                      isManualForm={isManualForm}
                      setIsManualForm={setIsManualForm}
                      isSecretLoading={isSecretLoading}
                      queryParams={`&plansDrawer=true&planId=${planId}&amount=${getAmount()}&checked=false&isRetry=true&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}`}
                      amount={getAmount()}
                      isDisabled={isDisabled}
                      handlePlaidBankPayment={handlePlaidBankPayment}
                      BankOrCardComp={
                        <div className="pt-10">
                          <StripeCardPaymentCheckoutForm
                            values={values}
                            handleChange={handleChangeCard}
                            isEdit={false}
                            iconType={iconType}
                            selectedState={selectedState}
                            setSelectedState={setSelectedState}
                            setIconType={setIconType}
                            cardErrMsg={cardErrMsg}
                            email={email}
                            setEmail={setEmail}
                            isPaymentLink={true}
                            isRetry={true}
                            formCheck={formCheck}
                            setFormCheck={setFormCheck}
                            formEmptyCheck={formEmptyCheck}
                            setFormEmptyCheck={setFormEmptyCheck}
                            amount={getAmount()}
                          />
                        </div>
                      }
                    />
                    <RetryPaymentStep
                      desktopStepMarker={
                        <DesktopStepMarker
                          step={3}
                          currentStep={currentStep}
                          completedSteps={completedSteps}
                          isLastStep
                          onClick={handleOnClick}
                        />
                      }
                      isRetryPayment={isRetryPayment}
                      currentStep={currentStep}
                      failedPayment={failedPayment}
                      isUpdateLoading={isUpdateLoading}
                      isUpdateRetryLoading={isUpdateRetryLoading}
                      showButtons={false}
                      buttonComp={
                        <div className="w-full flex justify-between gap-4 ">
                          <CardPaymentButton
                            buttonText="Update and retry"
                            className="w-full"
                            values={values}
                            email={email}
                            isUpdateAndPay={true}
                            amount={getAmount()}
                            isRecurring={true}
                            handleClick={() => {
                              setIsRetry(true);
                            }}
                            ref={cardRef1}
                            verifyStripeCardPayment={verifyStripeCardPayment}
                          />
                          <CardPaymentButton
                            buttonText="Update Only"
                            className="w-full"
                            values={values}
                            email={email}
                            amount={getAmount()}
                            isUpdateAndPay={false}
                            isRecurring={true}
                            handleClick={() => {
                              setIsRetry(false);
                            }}
                            ref={cardRef}
                            verifyStripeCardPayment={verifyStripeCardPayment}
                          />
                        </div>
                      }
                    />
                  </Elements>
                </div>
                {showFinalDisclosure && (
                  <DisclosureFinal
                    isOpen={showFinalDisclosure}
                    generalMarkers={generalMarkers}
                    handleAccept={handleAccept}
                    isDrawer={true}
                  />
                )}
              </>
            ) : (
              <>
                <div className={showFinalDisclosure ? "hidden none" : ""}>
                  <PaymentComponent
                    desktopStepMarker={
                      <DesktopStepMarker
                        step={2}
                        currentStep={currentStep}
                        completedSteps={completedSteps}
                        isLastStep={!isRetryPayment}
                        onClick={handleOnClick}
                      />
                    }
                    currentStep={currentStep}
                    completedSteps={completedSteps}
                    setCompletedSteps={setCompletedSteps}
                    isRetryPayment={isRetryPayment}
                    isAddNewCard={isAddNewCard}
                    setIsAddNewCard={setIsAddNewCard}
                    setDataPayment={setDataPayment}
                    dataPayment={dataPayment}
                    setCurrentStep={setCurrentStep}
                    walletList={walletList}
                    isDataLoading={isDataLoading}
                    setSavedCardsEmail={setSavedCardsEmail}
                    setShowPreview={setShowPreview}
                    paymentMethodList={paymentMethodList}
                    setSelectedMethod={setSelectedMethod}
                    onPaymentMethodChange={onPaymentMethodChange}
                    cardNumber={cardNumber}
                    setIconType={setIconType}
                    setValues={setValues}
                    values={values}
                    setIsRingLoading={setIsRingLoading}
                    setBankName={setBankName}
                    setBank={setBank}
                    setErrMsg={setErrMsg}
                    iconType={iconType}
                    setcardNumber={setcardNumber}
                    setIsDateErr={setIsDateErr}
                    setnumberNotmatchedError={setnumberNotmatchedError}
                    setSelectedState={setSelectedState}
                    selectedMethod={selectedMethod}
                    selectedState={selectedState}
                    isDateErr={isDateErr}
                    numberNotmatchedError={numberNotmatchedError}
                    bankName={bankName}
                    isRingLoading={isRingLoading}
                    email={email}
                    setEmail={setEmail}
                    data={data}
                    setIsErr={setIsErr}
                    setCardErrMsg={setCardErrMsg}
                    cardErrMsg={cardErrMsg}
                    isErr={isErr}
                    handleGooglePay={handleGooglePay}
                    handlePrev={handlePrev}
                    createPayPalIntent={createPayPalIntent}
                    isGoogleLoading={isGoogleLoading}
                    handleApplePay={handleApplePay}
                    setAmtErr={setAmtErr}
                    amtErr={amtErr}
                    isManualForm={isManualForm}
                    setIsManualForm={setIsManualForm}
                    amount={getAmount()}
                    isDisabled={isDisabled}
                    isSecretLoading={isSecretLoading}
                    handlePlaidBankPayment={handlePlaidBankPayment}
                    queryParams={`&plansDrawer=true&planId=${planId}&amount=${getAmount()}&checked=false&isRetry=true&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}`}
                  />
                  <RetryPaymentStep
                    desktopStepMarker={
                      <DesktopStepMarker
                        step={3}
                        currentStep={currentStep}
                        completedSteps={completedSteps}
                        isLastStep
                        onClick={handleOnClick}
                      />
                    }
                    isRetryPayment={isRetryPayment}
                    currentStep={currentStep}
                    failedPayment={failedPayment}
                    isUpdateLoading={isUpdateLoading}
                    showButtons={showUpdateButtons}
                    onUpdatePaymentPlan={onUpdatePaymentPlan}
                    isUpdateRetryLoading={isUpdateRetryLoading}
                    buttonComp={
                      <div className="w-full flex justify-between gap-4 ">
                        {selectedMethod === "Cash App Pay" && clientSecret ? (
                          <Elements
                            stripe={stripePromise}
                            options={{ clientSecret }}
                          >
                            <CashAppForm
                              isRecurring={true}
                              cashAppURL={`${
                                window.location.href
                              }?plansDrawer=true&amount=${getAmount()}&method=cashApp&isRetry=true&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}&planId=${planId}&checked=false`}
                              isRetry={true}
                              hasFuture={true}
                              handleClick={() => {
                                setIsRetry(true);
                              }}
                              ref={cashAppRef1}
                              buttonText="Update and retry"
                            />
                          </Elements>
                        ) : selectedMethod === "Amazon Pay" && clientSecret ? (
                          <Elements
                            stripe={stripePromise}
                            options={{ clientSecret }}
                          >
                            <AmazonPayForm
                              isRecurring={true}
                              amount={getAmount()}
                              stripeAmazonPayURL={`${
                                window.location.href
                              }?plansDrawer=true&amount=${getAmount()}&method=amazonPay&isRetry=true&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}&planId=${planId}&checked=false`}
                              isRetry={true}
                              hasFuture={true}
                              handleClick={() => {
                                setIsRetry(true);
                              }}
                              ref={amazonRef1}
                              buttonText="Update and retry"
                            />
                          </Elements>
                        ) : selectedMethod === "Bank" &&
                          checkBankManualFormOrPlaid({
                            manual_ach: portalSettings?.manual_ach,
                            validate_bank_account:
                              portalSettings?.validate_bank_account,
                            isManualForm,
                          }) ? (
                          <PlaidBankButton
                            isLoading={isLinkTokenLoading}
                            linkToken={linkToken}
                            buttonText="Update and retry"
                            email={email}
                            handleClick={() => {
                              setIsRetry(true);
                            }}
                            ref={bankRef1}
                            handlePlaidBankPayment={handlePlaidBankPayment}
                          />
                        ) : selectedMethod === "PayPal" ? (
                          <Button
                            isLoading={isUpdateRetryLoading}
                            text="Update and retry"
                            className="!w-full"
                            onClick={() => createPayPalIntent("isRetry")}
                          />
                        ) : null}

                        {selectedMethod === "Cash App Pay" && clientSecret ? (
                          <Elements
                            stripe={stripePromise}
                            options={{ clientSecret }}
                          >
                            <CashAppForm
                              isRecurring={true}
                              cashAppURL={`${
                                window.location.href
                              }?plansDrawer=true&amount=${getAmount()}&method=cashApp&isRetry=false&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}&planId=${planId}&checked=false`}
                              isRetry={true}
                              hasFuture={true}
                              handleClick={() => {
                                setIsRetry(false);
                              }}
                              buttonText="Update Only"
                            />
                          </Elements>
                        ) : selectedMethod === "Amazon Pay" && clientSecret ? (
                          <Elements
                            stripe={stripePromise}
                            options={{ clientSecret }}
                          >
                            <AmazonPayForm
                              isRecurring={true}
                              amount={getAmount()}
                              stripeAmazonPayURL={`${
                                window.location.href
                              }?plansDrawer=true&amount=${getAmount()}&method=amazonPay&isRetry=false&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}&planId=${planId}&checked=false`}
                              isRetry={true}
                              hasFuture={true}
                              handleClick={() => {
                                setIsRetry(false);
                              }}
                              ref={amazonRef}
                              buttonText="Update Only"
                            />
                          </Elements>
                        ) : selectedMethod === "Bank" &&
                          checkBankManualFormOrPlaid({
                            manual_ach: portalSettings?.manual_ach,
                            validate_bank_account:
                              portalSettings?.validate_bank_account,
                            isManualForm,
                          }) ? (
                          <PlaidBankButton
                            isLoading={isLinkTokenLoading}
                            linkToken={linkToken}
                            buttonText="Update Only"
                            email={email}
                            handleClick={() => {
                              setIsRetry(false);
                            }}
                            ref={bankRef}
                            handlePlaidBankPayment={handlePlaidBankPayment}
                          />
                        ) : selectedMethod === "PayPal" ? (
                          <Button
                            isLoading={isUpdateLoading}
                            text="Update Only"
                            className="!w-full"
                            onClick={() => createPayPalIntent()}
                          />
                        ) : null}
                      </div>
                    }
                  />
                </div>
                {showFinalDisclosure && (
                  <DisclosureFinal
                    isOpen={showFinalDisclosure}
                    generalMarkers={generalMarkers}
                    handleAccept={handleAccept}
                    isDrawer={true}
                  />
                )}
              </>
            )
          ) : (
            <>
              <div className={showFinalDisclosure ? "hidden none" : ""}>
                <PaymentComponent
                  desktopStepMarker={
                    <DesktopStepMarker
                      step={2}
                      currentStep={currentStep}
                      completedSteps={completedSteps}
                      isLastStep={!isRetryPayment}
                      onClick={handleOnClick}
                    />
                  }
                  showButtons={showButtons}
                  completedSteps={completedSteps}
                  setCompletedSteps={setCompletedSteps}
                  currentStep={currentStep}
                  isRetryPayment={isRetryPayment}
                  isAddNewCard={isAddNewCard}
                  setIsAddNewCard={setIsAddNewCard}
                  setDataPayment={setDataPayment}
                  dataPayment={dataPayment}
                  setCurrentStep={setCurrentStep}
                  walletList={walletList}
                  isDataLoading={isDataLoading}
                  setSavedCardsEmail={setSavedCardsEmail}
                  setShowPreview={setShowPreview}
                  paymentMethodList={paymentMethodList}
                  setSelectedMethod={setSelectedMethod}
                  onPaymentMethodChange={onPaymentMethodChange}
                  cardNumber={cardNumber}
                  setIconType={setIconType}
                  setValues={setValues}
                  values={values}
                  setIsRingLoading={setIsRingLoading}
                  setBankName={setBankName}
                  setBank={setBank}
                  setErrMsg={setErrMsg}
                  iconType={iconType}
                  setcardNumber={setcardNumber}
                  setIsDateErr={setIsDateErr}
                  setnumberNotmatchedError={setnumberNotmatchedError}
                  setSelectedState={setSelectedState}
                  selectedMethod={selectedMethod}
                  selectedState={selectedState}
                  isDateErr={isDateErr}
                  numberNotmatchedError={numberNotmatchedError}
                  bankName={bankName}
                  isRingLoading={isRingLoading}
                  email={email}
                  setEmail={setEmail}
                  data={data}
                  setIsErr={setIsErr}
                  setCardErrMsg={setCardErrMsg}
                  cardErrMsg={cardErrMsg}
                  isErr={isErr}
                  handleGooglePay={handleGooglePay}
                  handlePrev={handlePrev}
                  createPayPalIntent={createPayPalIntent}
                  isGoogleLoading={isGoogleLoading}
                  handleApplePay={handleApplePay}
                  setAmtErr={setAmtErr}
                  amtErr={amtErr}
                  isManualForm={isManualForm}
                  setIsManualForm={setIsManualForm}
                  amount={getAmount()}
                  isDisabled={isDisabled}
                  cashAppRef={cashAppRef}
                  bankRef={bankRef}
                  cardRef={cardRef}
                  amazonRef={amazonRef}
                  isSecretLoading={isSecretLoading}
                  handlePlaidBankPayment={handlePlaidBankPayment}
                  verifyStripeCardPayment={handleStripeCardPayment}
                  queryParams={`&plansDrawer=true&planId=${planId}&amount=${getAmount()}&checked=false&isRetry=true&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}`}
                />
              </div>
              {showFinalDisclosure && (
                <DisclosureFinal
                  isOpen={showFinalDisclosure}
                  generalMarkers={generalMarkers}
                  handleAccept={handleAccept}
                  isDrawer={true}
                />
              )}
            </>
          )}
        </div>
      </div>

      {isLessThan769 && (
        <div className="lg:hidden flex flex-col w-full">
          <div
            className={`showFinalDisclosure ? "hidden none" : "" px-5 py-5 w-full`}
          >
            <Stepper
              currentStep={currentStep}
              Steps={isRetryPayment ? 3 : 2}
              completedSteps={completedSteps}
              handleOnClick={handleOnClick}
            />
          </div>
          <div className="w-full flex flex-col gap-5">
            {showFinalDisclosure ? (
              <></>
            ) : (
              <UpdateScheduleTable
                currentStep={currentStep}
                addNewRow={addNewRow}
                isRetryPayment={isRetryPayment}
                data={data}
                setData={setData}
                setIsStartDate={setIsStartDate}
                isStartDate={isStartDate}
                setIsApiCall={setIsApiCall}
                handleDebouncedChange={handleDebouncedChange}
                setAmtErr={setAmtErr}
                amtErr={amtErr}
                removeRow={removeRow}
                handleSave={handleSave}
                handleChange={handleChange}
                isLoading={isLoading}
                setIsSelectStartDate={setIsSelectStartDate}
                startDate={startDate}
                setStartDate={setStartDate}
                isEndDateError={isEndDateError}
                dateErrMsg={dateErrMsg}
                setDateErrMsg={setDateErrMsg}
              />
            )}
          </div>
          {(currentStep === 2 || currentStep === 3) && (
            <>
              {isRetryPayment ? (
                bankSecret &&
                selectedMethod === "Bank" &&
                paymentPermission?.ach_gateway_name.name ===
                  PaymentGateway.STRIPE &&
                !isAddNewCard ? (
                  <>
                    <div className={showFinalDisclosure ? "hidden none" : ""}>
                      <Elements
                        stripe={stripePromise}
                        options={bankFormOptions}
                      >
                        {currentStep === 2 && (
                          <PaymentComponent
                            setCompletedSteps={setCompletedSteps}
                            completedSteps={completedSteps}
                            currentStep={currentStep}
                            isRetryPayment={isRetryPayment}
                            isAddNewCard={isAddNewCard}
                            setIsAddNewCard={setIsAddNewCard}
                            setDataPayment={setDataPayment}
                            dataPayment={dataPayment}
                            setCurrentStep={setCurrentStep}
                            walletList={walletList}
                            isDataLoading={isDataLoading}
                            setSavedCardsEmail={setSavedCardsEmail}
                            setShowPreview={setShowPreview}
                            paymentMethodList={paymentMethodList}
                            setSelectedMethod={setSelectedMethod}
                            onPaymentMethodChange={onPaymentMethodChange}
                            cardNumber={cardNumber}
                            setIconType={setIconType}
                            setValues={setValues}
                            values={values}
                            setIsRingLoading={setIsRingLoading}
                            setBankName={setBankName}
                            setBank={setBank}
                            setErrMsg={setErrMsg}
                            iconType={iconType}
                            setcardNumber={setcardNumber}
                            setIsDateErr={setIsDateErr}
                            setnumberNotmatchedError={setnumberNotmatchedError}
                            setSelectedState={setSelectedState}
                            selectedMethod={selectedMethod}
                            selectedState={selectedState}
                            isDateErr={isDateErr}
                            numberNotmatchedError={numberNotmatchedError}
                            bankName={bankName}
                            isRingLoading={isRingLoading}
                            email={email}
                            setEmail={setEmail}
                            data={data}
                            setIsErr={setIsErr}
                            setCardErrMsg={setCardErrMsg}
                            cardErrMsg={cardErrMsg}
                            isErr={isErr}
                            handleGooglePay={handleGooglePay}
                            handlePrev={handlePrev}
                            createPayPalIntent={createPayPalIntent}
                            isGoogleLoading={isGoogleLoading}
                            handleApplePay={handleApplePay}
                            setAmtErr={setAmtErr}
                            amtErr={amtErr}
                            isManualForm={isManualForm}
                            setIsManualForm={setIsManualForm}
                            amount={getAmount()}
                            handlePlaidBankPayment={handlePlaidBankPayment}
                            queryParams={`&plansDrawer=true&planId=${planId}&amount=${getAmount()}&checked=false&isRetry=true&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}`}
                            isDisabled={isDisabled}
                            isSecretLoading={isSecretLoading}
                            BankOrCardComp={
                              <div className="pt-10">
                                <StripeBankForm
                                  email={email}
                                  setEmail={setEmail}
                                  isSecretLoading={isLoading}
                                  isRetry={true}
                                  setIsDisable={setIsDisabled}
                                />
                              </div>
                            }
                          />
                        )}
                        {currentStep === 3 && (
                          <RetryPaymentStep
                            isRetryPayment={isRetryPayment}
                            currentStep={currentStep}
                            failedPayment={failedPayment}
                            isUpdateLoading={isUpdateLoading}
                            showButtons={false}
                            isUpdateRetryLoading={isUpdateRetryLoading}
                            buttonComp={
                              <div className="w-full flex justify-between gap-4 ">
                                <BankPaymentButton
                                  buttonText="Update and retry"
                                  className="w-full"
                                  isLoading={isUpdateRetryLoading}
                                  isRecurring={true}
                                  ref={bankRef1}
                                  handleClick={() => {
                                    setIsRetry(true);
                                  }}
                                  stripeBankURL={`${
                                    window.location.href
                                  }?plansDrawer=true&amount=${getAmount()}&method=bank&isRetry=true&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}&planId=${planId}&checked=false`}
                                />
                                <BankPaymentButton
                                  buttonText="Update Only"
                                  className="w-full"
                                  isLoading={isUpdateLoading}
                                  isRecurring={true}
                                  handleClick={() => {
                                    setIsRetry(false);
                                  }}
                                  ref={bankRef}
                                  stripeBankURL={`${
                                    window.location.href
                                  }?plansDrawer=true&amount=${getAmount()}&method=bank&isRetry=false&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}&planId=${planId}&checked=false`}
                                />
                              </div>
                            }
                          />
                        )}
                      </Elements>
                    </div>
                    {showFinalDisclosure && (
                      <DisclosureFinal
                        isOpen={showFinalDisclosure}
                        generalMarkers={generalMarkers}
                        handleAccept={handleAccept}
                        isDrawer={true}
                      />
                    )}
                  </>
                ) : selectedMethod === "Card" &&
                  paymentPermission?.cc_gateway_name?.name ===
                    PaymentGateway.STRIPE &&
                  !isAddNewCard ? (
                  <>
                    <div className={showFinalDisclosure ? "hidden none" : ""}>
                      <Elements stripe={stripePromise}>
                        {currentStep === 2 && (
                          <PaymentComponent
                            currentStep={currentStep}
                            completedSteps={completedSteps}
                            setCompletedSteps={setCompletedSteps}
                            isRetryPayment={isRetryPayment}
                            isAddNewCard={isAddNewCard}
                            setIsAddNewCard={setIsAddNewCard}
                            setDataPayment={setDataPayment}
                            dataPayment={dataPayment}
                            setCurrentStep={setCurrentStep}
                            walletList={walletList}
                            isDataLoading={isDataLoading}
                            setSavedCardsEmail={setSavedCardsEmail}
                            setShowPreview={setShowPreview}
                            paymentMethodList={paymentMethodList}
                            setSelectedMethod={setSelectedMethod}
                            onPaymentMethodChange={onPaymentMethodChange}
                            cardNumber={cardNumber}
                            setIconType={setIconType}
                            setValues={setValues}
                            values={values}
                            setIsRingLoading={setIsRingLoading}
                            setBankName={setBankName}
                            setBank={setBank}
                            setErrMsg={setErrMsg}
                            iconType={iconType}
                            setcardNumber={setcardNumber}
                            setIsDateErr={setIsDateErr}
                            setnumberNotmatchedError={setnumberNotmatchedError}
                            setSelectedState={setSelectedState}
                            selectedMethod={selectedMethod}
                            selectedState={selectedState}
                            isDateErr={isDateErr}
                            numberNotmatchedError={numberNotmatchedError}
                            bankName={bankName}
                            isRingLoading={isRingLoading}
                            email={email}
                            setEmail={setEmail}
                            data={data}
                            setIsErr={setIsErr}
                            setCardErrMsg={setCardErrMsg}
                            cardErrMsg={cardErrMsg}
                            isErr={isErr}
                            handleGooglePay={handleGooglePay}
                            handlePrev={handlePrev}
                            createPayPalIntent={createPayPalIntent}
                            isGoogleLoading={isGoogleLoading}
                            handleApplePay={handleApplePay}
                            setAmtErr={setAmtErr}
                            amtErr={amtErr}
                            isManualForm={isManualForm}
                            setIsManualForm={setIsManualForm}
                            isSecretLoading={isSecretLoading}
                            queryParams={`&plansDrawer=true&planId=${planId}&amount=${getAmount()}&checked=false&isRetry=true&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}`}
                            amount={getAmount()}
                            isDisabled={isDisabled}
                            handlePlaidBankPayment={handlePlaidBankPayment}
                            BankOrCardComp={
                              <div className="pt-10">
                                <StripeCardPaymentCheckoutForm
                                  values={values}
                                  handleChange={handleChangeCard}
                                  isEdit={false}
                                  iconType={iconType}
                                  selectedState={selectedState}
                                  setSelectedState={setSelectedState}
                                  setIconType={setIconType}
                                  cardErrMsg={cardErrMsg}
                                  email={email}
                                  setEmail={setEmail}
                                  isPaymentLink={true}
                                  amount={getAmount()}
                                  isRetry={true}
                                  formCheck={formCheck}
                                  setFormCheck={setFormCheck}
                                  formEmptyCheck={formEmptyCheck}
                                  setFormEmptyCheck={setFormEmptyCheck}
                                />
                              </div>
                            }
                          />
                        )}
                        {currentStep === 3 && (
                          <RetryPaymentStep
                            isRetryPayment={isRetryPayment}
                            currentStep={currentStep}
                            failedPayment={failedPayment}
                            isUpdateLoading={isUpdateLoading}
                            isUpdateRetryLoading={isUpdateRetryLoading}
                            showButtons={false}
                            buttonComp={
                              <div className="w-full flex justify-between gap-4 ">
                                <CardPaymentButton
                                  buttonText="Update and retry"
                                  className="w-full"
                                  values={values}
                                  email={email}
                                  amount={getAmount()}
                                  isRecurring={true}
                                  ref={cardRef1}
                                  handleClick={() => {
                                    setIsRetry(true);
                                  }}
                                  isUpdateAndPay={true}
                                  verifyStripeCardPayment={
                                    verifyStripeCardPayment
                                  }
                                />
                                <CardPaymentButton
                                  buttonText="Update Only"
                                  className="w-full"
                                  values={values}
                                  email={email}
                                  amount={getAmount()}
                                  isRecurring={true}
                                  handleClick={() => {
                                    setIsRetry(false);
                                  }}
                                  isUpdateAndPay={false}
                                  ref={cardRef}
                                  verifyStripeCardPayment={
                                    verifyStripeCardPayment
                                  }
                                />
                              </div>
                            }
                          />
                        )}
                      </Elements>
                    </div>
                    {showFinalDisclosure && (
                      <DisclosureFinal
                        isOpen={showFinalDisclosure}
                        generalMarkers={generalMarkers}
                        handleAccept={handleAccept}
                        isDrawer={true}
                      />
                    )}
                  </>
                ) : (
                  <>
                    <div className={showFinalDisclosure ? "hidden none" : ""}>
                      {currentStep === 2 && (
                        <PaymentComponent
                          currentStep={currentStep}
                          completedSteps={completedSteps}
                          setCompletedSteps={setCompletedSteps}
                          isRetryPayment={isRetryPayment}
                          isAddNewCard={isAddNewCard}
                          setIsAddNewCard={setIsAddNewCard}
                          setDataPayment={setDataPayment}
                          dataPayment={dataPayment}
                          setCurrentStep={setCurrentStep}
                          walletList={walletList}
                          isDataLoading={isDataLoading}
                          setSavedCardsEmail={setSavedCardsEmail}
                          setShowPreview={setShowPreview}
                          paymentMethodList={paymentMethodList}
                          setSelectedMethod={setSelectedMethod}
                          onPaymentMethodChange={onPaymentMethodChange}
                          cardNumber={cardNumber}
                          setIconType={setIconType}
                          setValues={setValues}
                          values={values}
                          setIsRingLoading={setIsRingLoading}
                          setBankName={setBankName}
                          setBank={setBank}
                          setErrMsg={setErrMsg}
                          iconType={iconType}
                          setcardNumber={setcardNumber}
                          setIsDateErr={setIsDateErr}
                          setnumberNotmatchedError={setnumberNotmatchedError}
                          setSelectedState={setSelectedState}
                          selectedMethod={selectedMethod}
                          selectedState={selectedState}
                          isDateErr={isDateErr}
                          numberNotmatchedError={numberNotmatchedError}
                          bankName={bankName}
                          isRingLoading={isRingLoading}
                          email={email}
                          setEmail={setEmail}
                          data={data}
                          setIsErr={setIsErr}
                          setCardErrMsg={setCardErrMsg}
                          cardErrMsg={cardErrMsg}
                          isErr={isErr}
                          handleGooglePay={handleGooglePay}
                          handlePrev={handlePrev}
                          createPayPalIntent={createPayPalIntent}
                          isGoogleLoading={isGoogleLoading}
                          handleApplePay={handleApplePay}
                          setAmtErr={setAmtErr}
                          amtErr={amtErr}
                          isManualForm={isManualForm}
                          setIsManualForm={setIsManualForm}
                          amount={getAmount()}
                          isDisabled={isDisabled}
                          isSecretLoading={isSecretLoading}
                          handlePlaidBankPayment={handlePlaidBankPayment}
                          queryParams={`&plansDrawer=true&planId=${planId}&amount=${getAmount()}&checked=false&isRetry=true&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}`}
                        />
                      )}
                      {currentStep === 3 && (
                        <RetryPaymentStep
                          isRetryPayment={isRetryPayment}
                          currentStep={currentStep}
                          failedPayment={failedPayment}
                          isUpdateLoading={isUpdateLoading}
                          showButtons={showUpdateButtons}
                          onUpdatePaymentPlan={onUpdatePaymentPlan}
                          isUpdateRetryLoading={isUpdateRetryLoading}
                          buttonComp={
                            <div className="w-full flex justify-between gap-4 ">
                              {selectedMethod === "Cash App Pay" &&
                              clientSecret ? (
                                <Elements
                                  stripe={stripePromise}
                                  options={{ clientSecret }}
                                >
                                  <CashAppForm
                                    isRecurring={true}
                                    cashAppURL={`${
                                      window.location.href
                                    }?plansDrawer=true&amount=${getAmount()}&method=cashApp&isRetry=true&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}&planId=${planId}&checked=false`}
                                    isRetry={true}
                                    hasFuture={true}
                                    handleClick={() => {
                                      setIsRetry(true);
                                    }}
                                    ref={cashAppRef1}
                                    buttonText="Update and retry"
                                  />
                                </Elements>
                              ) : selectedMethod === "Amazon Pay" &&
                                clientSecret ? (
                                <Elements
                                  stripe={stripePromise}
                                  options={{ clientSecret }}
                                >
                                  <AmazonPayForm
                                    isRecurring={true}
                                    amount={getAmount()}
                                    stripeAmazonPayURL={`${
                                      window.location.href
                                    }?plansDrawer=true&amount=${getAmount()}&method=amazonPay&isRetry=true&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}&planId=${planId}&checked=false`}
                                    isRetry={true}
                                    hasFuture={true}
                                    handleClick={() => {
                                      setIsRetry(true);
                                    }}
                                    ref={amazonRef1}
                                    buttonText="Update and retry"
                                  />
                                </Elements>
                              ) : selectedMethod === "Bank" &&
                                checkBankManualFormOrPlaid({
                                  manual_ach: portalSettings?.manual_ach,
                                  validate_bank_account:
                                    portalSettings?.validate_bank_account,
                                  isManualForm,
                                }) ? (
                                <PlaidBankButton
                                  isLoading={isLinkTokenLoading}
                                  linkToken={linkToken}
                                  buttonText="Update and retry"
                                  email={email}
                                  handleClick={() => {
                                    setIsRetry(true);
                                  }}
                                  ref={bankRef1}
                                  handlePlaidBankPayment={
                                    handlePlaidBankPayment
                                  }
                                />
                              ) : selectedMethod === "PayPal" ? (
                                <Button
                                  isLoading={isUpdateRetryLoading}
                                  text="Update and retry"
                                  className="!w-full"
                                  onClick={() => createPayPalIntent("isRetry")}
                                />
                              ) : null}

                              {selectedMethod === "Cash App Pay" &&
                              clientSecret ? (
                                <Elements
                                  stripe={stripePromise}
                                  options={{ clientSecret }}
                                >
                                  <CashAppForm
                                    isRecurring={true}
                                    cashAppURL={`${
                                      window.location.href
                                    }?plansDrawer=true&amount=${getAmount()}&method=cashApp&isRetry=false&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}&planId=${planId}&checked=false`}
                                    isRetry={true}
                                    hasFuture={true}
                                    handleClick={() => {
                                      setIsRetry(false);
                                    }}
                                    ref={cashAppRef}
                                    buttonText="Update Only"
                                  />
                                </Elements>
                              ) : selectedMethod === "Amazon Pay" &&
                                clientSecret ? (
                                <Elements
                                  stripe={stripePromise}
                                  options={{ clientSecret }}
                                >
                                  <AmazonPayForm
                                    isRecurring={true}
                                    amount={getAmount()}
                                    stripeAmazonPayURL={`${
                                      window.location.href
                                    }?plansDrawer=true&amount=${getAmount()}&method=amazonPay&isRetry=false&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}&planId=${planId}&checked=false`}
                                    isRetry={true}
                                    hasFuture={true}
                                    handleClick={() => {
                                      setIsRetry(false);
                                    }}
                                    ref={amazonRef}
                                    buttonText="Update Only"
                                  />
                                </Elements>
                              ) : selectedMethod === "Bank" &&
                                checkBankManualFormOrPlaid({
                                  manual_ach: portalSettings?.manual_ach,
                                  validate_bank_account:
                                    portalSettings?.validate_bank_account,
                                  isManualForm,
                                }) ? (
                                <PlaidBankButton
                                  isLoading={isLinkTokenLoading}
                                  linkToken={linkToken}
                                  buttonText="Update Only"
                                  email={email}
                                  handleClick={() => {
                                    setIsRetry(false);
                                  }}
                                  ref={bankRef}
                                  handlePlaidBankPayment={
                                    handlePlaidBankPayment
                                  }
                                />
                              ) : selectedMethod === "PayPal" ? (
                                <Button
                                  isLoading={isUpdateLoading}
                                  text="Update Only"
                                  className="!w-full"
                                  onClick={() => createPayPalIntent()}
                                />
                              ) : null}
                            </div>
                          }
                        />
                      )}
                    </div>
                    {showFinalDisclosure && (
                      <DisclosureFinal
                        isOpen={showFinalDisclosure}
                        generalMarkers={generalMarkers}
                        handleAccept={handleAccept}
                        isDrawer={true}
                      />
                    )}
                  </>
                )
              ) : (
                <>
                  <div className={showFinalDisclosure ? "hidden none" : ""}>
                    {currentStep === 2 && (
                      <PaymentComponent
                        showButtons={showButtons}
                        completedSteps={completedSteps}
                        setCompletedSteps={setCompletedSteps}
                        currentStep={currentStep}
                        isRetryPayment={isRetryPayment}
                        isAddNewCard={isAddNewCard}
                        setIsAddNewCard={setIsAddNewCard}
                        setDataPayment={setDataPayment}
                        dataPayment={dataPayment}
                        setCurrentStep={setCurrentStep}
                        walletList={walletList}
                        isDataLoading={isDataLoading}
                        setSavedCardsEmail={setSavedCardsEmail}
                        setShowPreview={setShowPreview}
                        paymentMethodList={paymentMethodList}
                        setSelectedMethod={setSelectedMethod}
                        onPaymentMethodChange={onPaymentMethodChange}
                        cardNumber={cardNumber}
                        setIconType={setIconType}
                        setValues={setValues}
                        values={values}
                        setIsRingLoading={setIsRingLoading}
                        setBankName={setBankName}
                        setBank={setBank}
                        setErrMsg={setErrMsg}
                        iconType={iconType}
                        setcardNumber={setcardNumber}
                        setIsDateErr={setIsDateErr}
                        setnumberNotmatchedError={setnumberNotmatchedError}
                        setSelectedState={setSelectedState}
                        selectedMethod={selectedMethod}
                        selectedState={selectedState}
                        isDateErr={isDateErr}
                        numberNotmatchedError={numberNotmatchedError}
                        bankName={bankName}
                        isRingLoading={isRingLoading}
                        email={email}
                        setEmail={setEmail}
                        data={data}
                        setIsErr={setIsErr}
                        setCardErrMsg={setCardErrMsg}
                        cardErrMsg={cardErrMsg}
                        isErr={isErr}
                        handleGooglePay={handleGooglePay}
                        handlePrev={handlePrev}
                        createPayPalIntent={createPayPalIntent}
                        isGoogleLoading={isGoogleLoading}
                        handleApplePay={handleApplePay}
                        setAmtErr={setAmtErr}
                        amtErr={amtErr}
                        isManualForm={isManualForm}
                        setIsManualForm={setIsManualForm}
                        amount={getAmount()}
                        isDisabled={isDisabled}
                        cashAppRef={cashAppRef}
                        bankRef={bankRef}
                        cardRef={cardRef}
                        amazonRef={amazonRef}
                        isSecretLoading={isSecretLoading}
                        handlePlaidBankPayment={handlePlaidBankPayment}
                        verifyStripeCardPayment={handleStripeCardPayment}
                        queryParams={`&plansDrawer=true&planId=${planId}&amount=${getAmount()}&checked=false&isRetry=true&updateMethod=${hasPaymentMethodChanged}&updateSchedule=${hasScheduleChanged}`}
                      />
                    )}
                  </div>
                  {showFinalDisclosure && (
                    <DisclosureFinal
                      isOpen={showFinalDisclosure}
                      generalMarkers={generalMarkers}
                      handleAccept={handleAccept}
                      isDrawer={true}
                    />
                  )}
                </>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

const UpdateScheduleTable = ({
  currentStep,
  isRetryPayment,
  data,
  setIsStartDate,
  isStartDate,
  setIsSelectStartDate,
  setIsApiCall,
  setData,
  handleDebouncedChange,
  setAmtErr = () => {},
  amtErr = null,
  addNewRow,
  removeRow,
  handleSave = () => {},
  handleChange = () => {},
  isLoading = false,
  isSelectedOffer = false,
  makePayment = false,
  startDate,
  setStartDate,
  desktopStepMarker,
  isEndDateError = false,
  dateErrMsg = null,
  setDateErrMsg = () => {},
}: UpdateScheduleTableProps) => {
  const dispatch = useAppDispatch();

  const calenderRef = useRef<any>();
  const { holidayList } = useAppSelector((state: RootState) => state.dashboard);
  const portalSettingsData = usePortalSettingsData();
  const userData = useUserData();
  const showFinalDisclosure = useShowFinalDisclosure();
  const isLessThan769 = useMediaQuery({ query: "(max-width: 769px)" });
  const [isTableExpanded, setIsTableExpanded] = useState<boolean>(false);
  const [openCalendar, setOpenCalendar] = useState<boolean>(false);
  const [selected, setSelected] = useState(ScheduleAmountTabs[0]);

  const calculatedData = useMemo(() => {
    let disabledCount = 0;
    let amount_type = "amount";

    if (data?.paymentPlan?.transactions?.length > 0) {
      amount_type =
        data?.paymentPlan?.transactions[0]?.amount_type === "P"
          ? "percent"
          : "amount";

      data?.paymentPlan?.transactions?.forEach((transaction: any) => {
        if (transaction?.status !== "Pending") disabledCount += 1;
      });
    }

    return { disabledCount, amount_type };
  }, [data]);

  const hasConvenienceFee = useMemo(
    () =>
      data?.paymentPlan?.transactions?.some(
        (transaction: any) => getTransactionConvenienceFee(transaction) > 0
      ) || false,
    [data?.paymentPlan?.transactions]
  );

  // The start date belongs to the existing plan and cannot be changed while
  // updating it. Pending transaction dates remain editable in the table.
  const checkStartDisabled = () => true;

  const getStartLimit = () => {
    const current = portalSettingsData?.start_date_limit_external;
    const currentArr = current?.split("-");
    if (currentArr?.length === 2) {
      let days = Number(currentArr[0]);

      if (currentArr[1] === "W") {
        days = days * 7;
      }

      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + days);

      return currentDate;
    } else {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + 365);

      return currentDate;
    }
  };

  const getEndLimit = () => {
    const configuredLimit = portalSettingsData?.end_date_limit_external?.trim();

    return configuredLimit
      ? getScheduleEndDateLimit(configuredLimit)
      : undefined;
  };

  const getOutstandingBalance = () =>
    Number(
      data?.customerData?.balance ??
        data?.balance ??
        userData?.data?.accountData?.balance ??
        0
    );

  const handleFixedAmountChange = (value: any) => {
    const tmpPaymentPlan = { ...data.paymentPlan, amount: value };

    if (tmpPaymentPlan?.schedule_amount?.toLowerCase() !== "fixed") {
      setData({ ...data, paymentPlan: tmpPaymentPlan });
      handleDebouncedChange();
      return;
    }

    const updatedTransactions = (tmpPaymentPlan.transactions || []).map(
      (transaction: any) =>
        transaction?.status === "Pending"
          ? {
              ...transaction,
              amount: value,
            }
          : transaction
    );
    const calculated = calculateAmountOutstanding(
      updatedTransactions,
      getOutstandingBalance()
    );

    setData({
      ...data,
      paymentPlan: {
        ...tmpPaymentPlan,
        transactions: calculated.dataArr,
        grand_total: calculated.totalAmount + calculated.totalFee,
        amount_subtotal: calculated.totalAmount,
      },
    });
    handleDebouncedChange();
  };

  return (
    <>
      <div className="lg:block hidden">
        <p
          data-update-step-heading="1"
          className={`${currentStep === 1 ? "text-btnPrimaryActive" : "text-txtPrimary"} relative flex h-10 items-center text-xl`}
        >
          {desktopStepMarker}
          Schedule payment
        </p>
        <div
          className={`${isRetryPayment ? "answerSection" : "answerSection1"} ${currentStep === 1 ? "open" : ""}`}
        >
          <div className="overflow-x-scroll h-full">
            <div className="w-full h-full lg:min-w-[600px]">
              <div className="flex mt-[24px] gap-x-[20px]">
                {/* CALENDER */}
                <div
                  ref={calenderRef}
                  className={`${
                    data.agreementType === "present" || isSelectedOffer
                      ? "cursor-not-allowed"
                      : ""
                  } relative`}
                >
                  {isLoading ? (
                    <div className="w-[178px]">
                      <div className="text-xs uppercase font-bold text-txtSecondary mb-[3px] leading-[15.62px]">
                        Start date
                      </div>
                      <Skeleton className="w-full h-[40px]" />
                    </div>
                  ) : (
                    <CustomTooltip
                      disabled={isLoading || !checkStartDisabled()}
                      place="top"
                      maxWidth="280px"
                      className="block text-left"
                      content={`<div class="text-xs leading-[18px] font-normal max-w-[250px]">${
                        isSelectedOffer
                          ? "The start date is set by your settlement offer and can't be changed."
                          : "This plan has already started, so its start date can't be changed. You can still adjust the dates of upcoming payments in the table below."
                      }</div>`}
                    >
                      <div className="relative">
                        <InputField
                          label="start date"
                          disabled={checkStartDisabled()}
                          readOnly
                          placeholder="MM/DD/YYYY"
                          value={dateToString(data.paymentPlan.start_date)}
                          noLabel={false}
                          _className="!cursor-not-allowed"
                          onClick={(e: any) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (!checkStartDisabled()) {
                              setOpenCalendar(!openCalendar);
                              setIsStartDate(!isStartDate);
                            }
                          }}
                        />
                        <span className="absolute right-[15px] bottom-[12px] opacity-50">
                          <CalendarIcon />
                        </span>
                      </div>
                    </CustomTooltip>
                  )}

                  {!checkStartDisabled() && openCalendar && (
                    <>
                      <CustomCalender
                        isDashFormat={true}
                        value={data.paymentPlan.start_date}
                        disableTiles={holidayList}
                        minDate={new Date()}
                        maxDate={getStartLimit()}
                        openCalendar={openCalendar}
                        setOpenCalendar={setOpenCalendar}
                        onChange={(date: any) => {
                          setIsApiCall(true);
                          setIsStartDate(false);
                          const tmp: any = { ...data.paymentPlan };
                          tmp.start_date = moment(dateToString(date)).format(
                            "MM/DD/YYYY"
                          );
                          setData({
                            ...data,
                            paymentPlan: tmp,
                          });
                          setStartDate(moment(date).format("MM/DD/YYYY"));
                          setOpenCalendar(false);
                          setIsSelectStartDate(true);
                        }}
                      />
                    </>
                  )}
                </div>

                {/* SELECT */}
                <div
                  className={`w-[178px] ${
                    data.agreementType === "present"
                      ? "pointer-events-none"
                      : "pointer-events-auto"
                  }`}
                >
                  <InputSelect
                    isSearchFeature
                    searchFieldType="number"
                    disabled={isLoading}
                    labelPlaceHolder=""
                    disabledList={
                      calculatedData?.disabledCount
                        ? [...Array(calculatedData?.disabledCount)].map(
                            (_, index) => index + 1
                          )
                        : []
                    }
                    label="number of transactions"
                    options={numberOfTransactions(
                      portalSettingsData?.transaction_limit || 15
                    )}
                    selected={findObjectByValue(
                      numberOfTransactions(
                        portalSettingsData?.transaction_limit
                      ),
                      data.paymentPlan?.no_of_transaction ||
                        data.paymentPlan?.transactions?.length ||
                        1
                    )}
                    setSelected={(val: any) => {
                      const tmp = { ...data.paymentPlan };
                      tmp.no_of_transaction = val.value;
                      setData({ ...data, paymentPlan: tmp, showUndo: true });
                      setIsApiCall(true);
                    }}
                  />
                </div>
              </div>

              {/* TABS */}
              <div
                className={`h-[40px] mt-[16px] ${
                  data.agreementType === "present"
                    ? "pointer-events-none"
                    : "pointer-events-auto"
                }`}
              >
                <TabsComp
                  disableHover={isSelectedOffer}
                  totalTabs={Tabs}
                  selected={findObjectByValue(
                    Tabs,
                    data.paymentPlan?.schedule_fld || "daily"
                  )}
                  setSelected={(val: any) => {
                    const tmp = { ...data.paymentPlan };
                    tmp.schedule_fld = val.value;
                    setData({ ...data, paymentPlan: tmp });

                    if (val.value === "custom") return;

                    setIsApiCall(true);
                  }}
                />
              </div>

              {/* SECTION3 */}
              <div className="mt-[24px] flex gap-x-[20px]">
                {/* SELECT */}
                <div
                  className={`w-[180px] ${
                    data.agreementType === "present" || data.isOfferEnabled
                      ? "pointer-events-none"
                      : "pointer-events-auto"
                  }`}
                >
                  <CustomTooltip
                    place="top"
                    maxWidth="280px"
                    className="block w-full text-left"
                    content={`<div class="text-xs leading-[18px] font-normal max-w-[250px]">The schedule type is set when a plan is created and can't be changed here.</div>`}
                  >
                    <InputSelect
                      label="Schedule Amount"
                      labelPlaceHolder="Schedule Amount"
                      defaultValue="Fixed"
                      disabled={true}
                      isInfoAvailable={true}
                      infoText="Define how you want the amount per transaction to be calculated."
                      infoClassName="w-[220px]"
                      value={data.paymentPlan?.schedule_amount.toLowerCase()}
                      options={ScheduleAmountList}
                      selected={findObjectByValue(
                        ScheduleAmountList,
                        data.paymentPlan?.schedule_amount.toLowerCase()
                      )}
                      setSelected={(val: any) => {
                        setSelected(ScheduleAmountTabs[0]);

                        if (makePayment) {
                          setIsApiCall(true);
                          const tmp = { ...data.paymentPlan };
                          tmp.schedule_amount = val.value;
                          setData({ ...data, paymentPlan: tmp });
                          if (val.value === "custom") {
                            const tmp = { ...data.paymentPlan };
                            tmp.schedule_amount = val.value;
                            setData({ ...data, paymentPlan: tmp });
                          }
                        } else {
                          if (makePayment) {
                            if (val.value === "custom") {
                              // setIsApiCall(true);
                              const tmp = { ...data.paymentPlan };
                              tmp.schedule_amount = val.value;
                              setData({ ...data, paymentPlan: tmp });
                            }
                          } else {
                            setIsApiCall(true);
                            const tmp = { ...data.paymentPlan };
                            tmp.schedule_amount = val.value;
                            setData({ ...data, paymentPlan: tmp });
                          }
                        }
                      }}
                    />
                  </CustomTooltip>
                </div>
                {data.paymentPlan?.schedule_amount?.toLowerCase() ===
                "custom" ? (
                  <div className="w-[180px]">
                    <div
                      className={`flex gap-x-[5px] mb-[3px] leading-[15.62px]`}
                    >
                      <p className="text-xs uppercase font-bold text-txtSecondary">
                        transaction type
                      </p>
                      <CustomTooltip
                        maxwidth="430px"
                        place="top"
                        id={`transaction-type-anchor`}
                        content={`<div class="text-xs leading-[18px] font-normal max-w-[200px]">You can either enter an amount or select a percentage of the total amount for each transaction.</div>`}
                      >
                        <InfoIcon
                          id={`transaction-type-anchor`}
                          strokeColor="var(--color-icon-bright)"
                          className="cursor-pointer group"
                          _className="group-hover:!stroke-iconObscure"
                        />
                      </CustomTooltip>
                    </div>
                    <div className="h-[40px]">
                      <TabsComp
                        totalTabs={ScheduleAmountTabs}
                        selected={findObjectByValue(
                          ScheduleAmountTabs,
                          calculatedData?.amount_type
                        )}
                        setSelected={(val: any) => {
                          setSelected(val);
                        }}
                        isInfo
                        disableHover
                        disabled
                      />
                    </div>
                  </div>
                ) : (
                  <div>
                    <div
                      className={`flex gap-x-[5px]  mb-[3px] items-center leading-[15.62px]`}
                    >
                      <p className="text-xs uppercase font-bold text-txtSecondary">
                        transaction amount
                      </p>
                      <CustomTooltip
                        maxwidth="430px"
                        place="top"
                        id={`transaction-amount-anchor`}
                        content={`<div class="text-xs leading-[18px] font-normal max-w-[410px]">${
                          data.paymentPlan?.schedule_amount.toLowerCase() ===
                          "fixed"
                            ? "Define a fixed amount per transaction."
                            : "The amount shown is automatically calculated by dividing the customer’s current balance by the total number of transactions. To change the transaction amount, select ‘Fixed’ or ‘Custom’."
                        }</div>`}
                      >
                        <InfoIcon
                          id={`transaction-amount-anchor`}
                          strokeColor="var(--color-icon-bright)"
                          className="cursor-pointer group"
                          _className="group-hover:!stroke-iconObscure"
                        />
                      </CustomTooltip>
                    </div>
                    <div
                      className={`relative max-w-[187px] ${
                        data.agreementType === "present"
                          ? "pointer-events-none"
                          : "pointer-events-auto"
                      }`}
                    >
                      <CustomAmountInput
                        inputValue={
                          data?.paymentPlan.schedule_amount.toLowerCase() ===
                          "auto"
                            ? data?.paymentPlan?.transactions?.[0]?.amount
                            : data?.paymentPlan?.amount
                        }
                        disabled={
                          data?.paymentPlan?.schedule_amount.toLowerCase() ===
                          "auto"
                        }
                        setinputValue={handleFixedAmountChange}
                        balance={userData?.data?.accountData?.balance}
                        setErr={setAmtErr}
                        className={`!pl-[23px]`}
                        showErr={false}
                        checkAmt={true}
                      />
                      {amtErr && (
                        <p className="text-red text-xs leading-[18.23px] w-full break-words">
                          {amtErr}
                        </p>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* TABLE COMPONENT */}
              <div className="mt-[8px] h-[480px] max-h-[480px]">
                <CustomTable1
                  dataArr={data?.paymentPlan?.transactions}
                  amountType={calculatedData?.amount_type}
                  isExpanded={isTableExpanded}
                  setIsExpanded={setIsTableExpanded}
                  isDateCustom={data.paymentPlan?.schedule_fld === "custom"}
                  isCustom={
                    data.paymentPlan?.schedule_amount?.toLowerCase() ===
                    "custom"
                      ? true
                      : false
                  }
                  isSettlementEnable={data?.isOfferEnabled}
                  totalAmount={data.paymentPlan?.amount_subtotal}
                  grandTotal={data.paymentPlan?.grand_total}
                  addNewRow={addNewRow}
                  removeRow={removeRow}
                  handleChange={handleChange}
                  handleSave={handleSave}
                  isLoading={isLoading}
                  data={data}
                  isdisplayFeeColumn={hasConvenienceFee}
                  makePayment={makePayment}
                  amtErr={amtErr}
                  getStartLimit={getEndLimit}
                  isEndDateError={isEndDateError}
                  dateErrMsg={dateErrMsg}
                  setDateErrMsg={setDateErrMsg}
                />
              </div>
              {/* Section 1 */}
            </div>
          </div>
        </div>
      </div>
      {isLessThan769 && (
        <div className="lg:hidden block">
          <div className="w-full flex lg:h-full flex-col gap-5">
            {currentStep === 1 && (
              <>
                <p className={`px-5  w-full text-blue`}>Schedule payment</p>
                <div className="px-5  w-full flex justify-between items-center gap-[10px]">
                  <div ref={calenderRef} className="relative w-full">
                    {isLoading ? (
                      <div className="w-full">
                        <div className="text-xs uppercase font-bold text-txtSecondary mb-[3px] leading-[15.62px]">
                          Start date
                        </div>
                        <Skeleton className="w-full h-[40px]" />
                      </div>
                    ) : (
                      <div className="relative">
                        <InputField
                          label="start date"
                          disabled={checkStartDisabled()}
                          readOnly
                          placeholder="MM/DD/YYYY"
                          value={dateToString(data.paymentPlan.start_date)}
                          noLabel={false}
                          _className="!cursor-not-allowed"
                          onClick={(e: any) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (!checkStartDisabled()) {
                              setOpenCalendar(!openCalendar);
                              setIsStartDate(!isStartDate);
                            }
                          }}
                        />
                        <span className="absolute right-[15px] bottom-[12px] opacity-50">
                          <CalendarIcon />
                        </span>
                      </div>
                    )}

                    {!checkStartDisabled() && openCalendar && (
                      <>
                        <CustomCalender
                          isDashFormat={true}
                          value={data.paymentPlan.start_date}
                          disableTiles={holidayList}
                          minDate={new Date()}
                          maxDate={getStartLimit()}
                          openCalendar={openCalendar}
                          setOpenCalendar={setOpenCalendar}
                          onChange={(date: any) => {
                            setIsApiCall(true);
                            setIsStartDate(false);
                            const tmp: any = { ...data.paymentPlan };
                            tmp.start_date = moment(dateToString(date)).format(
                              "MM/DD/YYYY"
                            );
                            setData({
                              ...data,
                              paymentPlan: tmp,
                            });
                            setStartDate(moment(date).format("MM/DD/YYYY"));
                            setOpenCalendar(false);
                            setIsSelectStartDate(true);
                          }}
                        />
                      </>
                    )}
                  </div>
                  <div
                    className={`w-full ${
                      data.agreementType === "present"
                        ? "pointer-events-none"
                        : "pointer-events-auto"
                    }`}
                  >
                    <InputSelect
                      isSearchFeature
                      searchFieldType="string"
                      labelPlaceHolder=""
                      label="frequency"
                      options={Tabs}
                      selected={findObjectByValue(
                        Tabs,
                        data.paymentPlan?.schedule_fld || "daily"
                      )}
                      setSelected={(val: any) => {
                        const tmp = { ...data.paymentPlan };
                        tmp.schedule_fld = val.value;
                        setData({ ...data, paymentPlan: tmp });

                        if (val.value === "custom") return;

                        setIsApiCall(true);
                      }}
                    />
                  </div>
                </div>
                <div className="px-5  w-full">
                  <div
                    className={`w-full ${
                      data.agreementType === "present"
                        ? "pointer-events-none"
                        : "pointer-events-auto"
                    }`}
                  >
                    <InputSelect
                      isSearchFeature
                      searchFieldType="number"
                      disabled={isLoading}
                      labelPlaceHolder=""
                      disabledList={
                        calculatedData?.disabledCount
                          ? [...Array(calculatedData?.disabledCount)].map(
                              (_, index) => index + 1
                            )
                          : []
                      }
                      label="number of transactions"
                      options={numberOfTransactions(
                        portalSettingsData?.transaction_limit || 15
                      )}
                      selected={findObjectByValue(
                        numberOfTransactions(
                          portalSettingsData?.transaction_limit
                        ),
                        data.paymentPlan?.no_of_transaction ||
                          data.paymentPlan?.transactions?.length ||
                          1
                      )}
                      setSelected={(val: any) => {
                        const tmp = { ...data.paymentPlan };
                        tmp.no_of_transaction = val.value;
                        setData({ ...data, paymentPlan: tmp, showUndo: true });
                        setIsApiCall(true);
                      }}
                    />
                  </div>
                </div>
                <div className="px-5 w-full flex justify-between items-center gap-[10px]">
                  <div
                    className={`w-full ${
                      data.agreementType === "present" || data.isOfferEnabled
                        ? "pointer-events-none"
                        : "pointer-events-auto"
                    }`}
                  >
                    <InputSelect
                      label="Schedule Amount"
                      labelPlaceHolder="Schedule Amount"
                      defaultValue="Fixed"
                      disabled={true}
                      isInfoAvailable={true}
                      infoText="Define how you want the amount per transaction to be calculated."
                      infoClassName="w-[220px]"
                      value={data.paymentPlan?.schedule_amount.toLowerCase()}
                      options={ScheduleAmountList}
                      selected={findObjectByValue(
                        ScheduleAmountList,
                        data.paymentPlan?.schedule_amount.toLowerCase()
                      )}
                      setSelected={(val: any) => {
                        setSelected(ScheduleAmountTabs[0]);
                        if (val.value === "custom") {
                          const tmp = { ...data.paymentPlan };
                          tmp.schedule_amount = val.value;
                          setData({ ...data, paymentPlan: tmp });
                        }
                      }}
                    />
                  </div>
                  {data.paymentPlan?.schedule_amount?.toLowerCase() ===
                  "custom" ? (
                    <div className="w-full">
                      <div
                        className={`flex gap-x-[5px] mb-[3px] leading-[15.62px]`}
                      >
                        <p className="text-xs uppercase font-bold text-txtSecondary">
                          transaction type
                        </p>
                        <CustomTooltip
                          maxwidth="430px"
                          place="top"
                          id={`transaction-type-anchor`}
                          content={`<div class="text-xs leading-[18px] font-normal max-w-[200px]">You can either enter an amount or select a percentage of the total amount for each transaction.</div>`}
                        >
                          <InfoIcon
                            id={`transaction-type-anchor`}
                            strokeColor="var(--color-icon-bright)"
                            className="cursor-pointer group"
                            _className="group-hover:!stroke-iconObscure"
                          />
                        </CustomTooltip>
                      </div>
                      <div className="h-[40px]">
                        <TabsComp
                          totalTabs={ScheduleAmountTabs}
                          selected={findObjectByValue(
                            ScheduleAmountTabs,
                            calculatedData?.amount_type
                          )}
                          setSelected={(val: any) => {
                            setSelected(val);
                          }}
                          isInfo
                          disableHover
                          disabled
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="w-full">
                      <div
                        className={`flex gap-x-[5px]  mb-[3px] items-center leading-[15.62px]`}
                      >
                        <p className="text-xs uppercase font-bold text-txtSecondary">
                          transaction amount
                        </p>
                        <CustomTooltip
                          maxwidth="430px"
                          place="top"
                          id={`transaction-amount-anchor`}
                          content={`<div class="text-xs leading-[18px] font-normal max-w-[410px]">${
                            data.paymentPlan?.schedule_amount.toLowerCase() ===
                            "fixed"
                              ? "Define a fixed amount per transaction."
                              : "The amount shown is automatically calculated by dividing the customer’s current balance by the total number of transactions. To change the transaction amount, select ‘Fixed’ or ‘Custom’."
                          }</div>`}
                        >
                          <InfoIcon
                            id={`transaction-amount-anchor`}
                            strokeColor="var(--color-icon-bright)"
                            className="cursor-pointer group"
                            _className="group-hover:!stroke-iconObscure"
                          />
                        </CustomTooltip>
                      </div>
                      <div
                        className={`relative ${
                          data.agreementType === "present"
                            ? "pointer-events-none"
                            : "pointer-events-auto"
                        }`}
                      >
                        <CustomAmountInput
                          inputValue={
                            data?.paymentPlan.schedule_amount.toLowerCase() ===
                            "auto"
                              ? data?.paymentPlan?.transactions?.[0]?.amount
                              : data?.paymentPlan?.amount
                          }
                          disabled={
                            data?.paymentPlan?.schedule_amount.toLowerCase() ===
                            "auto"
                          }
                          setinputValue={handleFixedAmountChange}
                          balance={userData?.data?.accountData?.balance}
                          setErr={setAmtErr}
                          className="!pl-[23px]"
                          showErr={false}
                          checkAmt={true}
                        />
                        {amtErr && (
                          <p className="text-red text-xs leading-[18.23px] w-full break-words">
                            {amtErr}
                          </p>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <CustomTable1
                  dataArr={data?.paymentPlan?.transactions}
                  amountType={calculatedData?.amount_type}
                  isExpanded={isTableExpanded}
                  setIsExpanded={setIsTableExpanded}
                  isDateCustom={data.paymentPlan?.schedule_fld === "custom"}
                  isCustom={
                    data.paymentPlan?.schedule_amount?.toLowerCase() ===
                    "custom"
                      ? true
                      : false
                  }
                  isSettlementEnable={data?.isOfferEnabled}
                  totalAmount={data.paymentPlan?.amount_subtotal}
                  grandTotal={data.paymentPlan?.grand_total}
                  addNewRow={addNewRow}
                  removeRow={removeRow}
                  handleChange={handleChange}
                  handleSave={handleSave}
                  isLoading={isLoading}
                  data={data}
                  isUpdatePlan={true}
                  getStartLimit={getEndLimit}
                  isdisplayFeeColumn={hasConvenienceFee}
                  isEndDateError={isEndDateError}
                  dateErrMsg={dateErrMsg}
                  setDateErrMsg={setDateErrMsg}
                />
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

const RetryPaymentStep = ({
  isRetryPayment,
  currentStep,
  failedPayment,
  isUpdateLoading,
  showButtons = false,
  buttonComp = <></>,
  desktopStepMarker,
  onUpdatePaymentPlan = () => {},
  isUpdateRetryLoading,
}: {
  isRetryPayment: boolean;
  currentStep: number;
  failedPayment: number;
  isUpdateLoading: boolean;
  showButtons?: boolean;
  buttonComp: any;
  desktopStepMarker?: React.ReactNode;
  onUpdatePaymentPlan?: (isRetry?: string) => void;
  isUpdateRetryLoading: boolean;
}) => {
  const isLessThan769 = useMediaQuery({ query: "(max-width: 769px)" });
  if (!isRetryPayment || Number(failedPayment || 0) <= 0) return null;

  return (
    <div className="lg:px-0 px-5">
      <div className="w-full h-[2px] bg-bgSecondary lg:block hidden"></div>
      <p
        data-update-step-heading="3"
        className={`${currentStep === 3 ? "text-btnPrimaryActive" : "text-txtPrimary"} relative lg:flex lg:h-10 lg:items-center lg:py-0 lg:text-xl text-lg py-1.5`}
      >
        {desktopStepMarker}
        Retry failed payment
      </p>
      <div
        className={`${
          !isLessThan769
            ? isRetryPayment
              ? "answerSection"
              : "answerSection1"
            : ""
        } ${currentStep === 3 ? "open" : ""}`}
      >
        <div className="w-full max-w-[530px]">
          <p className="lg:py-10 py-5 lg:leading-[30px] leading-[20.83px] text-base lg:text-lg text-txtSecondary">
            Would you like to retry the last failed payment of{" "}
            {formatCurrency(failedPayment) || "$0.00"} now, or should we apply
            this new payment method to future transactions only?
          </p>
          {showButtons ? (
            <div className="w-full flex justify-between gap-4 ">
              <Button
                isLoading={isUpdateRetryLoading}
                text="Update and retry"
                className="!w-full"
                onClick={() => onUpdatePaymentPlan("isRetry")}
              />

              <Button
                isLoading={isUpdateLoading}
                className="!w-full"
                text="Update Only"
                type="button"
                onClick={() => onUpdatePaymentPlan()}
              />
            </div>
          ) : (
            buttonComp
          )}
        </div>
      </div>
    </div>
  );
};

type LinkFormData = {
  publicToken: string;
  accountId: string;
  bankName: string;
};

const PlaidBankButton = forwardRef(
  (
    {
      linkToken,
      email,
      buttonText,
      isLoading,
      handleClick,
      handlePlaidBankPayment = async (
        val: any,
        isCCTokenAvailable: boolean
      ): Promise<void> => {
        return Promise.resolve();
      },
    }: {
      linkToken: string | null;
      email: string;
      buttonText: string;
      isLoading: boolean;
      handleClick: () => void;
      handlePlaidBankPayment?: (
        val: any,
        isCCTokenAvailable: boolean
      ) => Promise<void>;
    },
    ref
  ) => {
    const dispatch = useAppDispatch();
    const userData = useUserData();
    const [isMakingPayment, setIsMakingPayment] = useState<boolean>(false);
    const portalSettings = usePortalSettingsData();
    const { clusterId: cluster_id } = useParams();

    const getPaymentToken = async (data: LinkFormData) => {
      setIsMakingPayment(true);
      try {
        let clusterid = userData?.data?.accountData?.clusterid;

        let payload = {
          public_token: data?.publicToken,
          bankAccountID: data?.accountId,
          clusterid: clusterid,
          accountid: userData?.data?.accountData?.accountid,
          email: email,
          slug: cluster_id || "",
        };
        let res: any = await dispatch(getPlaidPaymentToken(payload)).unwrap();
        if (res?.body?.success) {
          const { address } = res?.body?.data;
          let values = {
            bankName: data?.bankName,
            bank: data?.bankName,
            choldername: userData?.data?.accountData?.first_name,
            routing_number: res?.body?.data?.routing_numebr,
            account_number: res?.body?.data?.account_number,
            gateway_name: res?.body?.data?.gateway_name,
            x_city: address?.city ?? "",
            x_address: address?.street ?? "",
            address2: "",
            x_zip: address?.postal_code ?? "",
            x_state: address?.region ?? "",
            x_country: address?.country ?? "",
            email,
            gateway_id: res?.body?.data?.gatewayId,
            cc_token: res?.body?.data?.cc_token,
            cc_token2: res?.body?.data?.cc_token2,
            pc_atid: res?.body?.data?.pc_atid,
            cppid: res?.body?.data?.cppid,
          };
          let isCCTokenAvailable =
            res?.body?.data?.cc_token &&
            res?.body?.data?.cc_token?.trim() !== "" &&
            res?.body?.data?.gateway_name === PaymentGateway.ACHQ;
          await handlePlaidBankPayment(values, isCCTokenAvailable);
        } else {
          dispatch(onSetFinalDisclosureLoading(false));
          dispatch(onSetShowDisclosure(false));
        }
      } catch (error) {
        console.log("getPaymentTokenerror =====", error);
      } finally {
        dispatch(onSetFinalDisclosureLoading(false));
        dispatch(onSetShowDisclosure(false));
        setIsMakingPayment(false);
      }
    };

    const onSuccess = useCallback(
      async (public_token?: string, metadata?: any) => {
        if (public_token && metadata) {
          let data = {
            publicToken: public_token,
            accountId: metadata?.account_id,
            bankName: metadata?.institution?.name,
          };
          await getPaymentToken(data);
        }
      },
      []
    );

    const config: Parameters<typeof usePlaidLink>[0] = {
      token: linkToken!,
      onSuccess: onSuccess,
      onExit: (error: PlaidLinkError | null) => {
        dispatch(onSetFinalDisclosureLoading(false));
        dispatch(onSetShowDisclosure(false));
        console.log("error =====", error);
      },
    };

    const { open, ready } = usePlaidLink(config);
    return (
      <Button
        text={buttonText}
        isDisabled={!ready || !linkToken}
        isLoading={isLoading || isMakingPayment}
        onClick={() => {
          // if (
          //   portalSettings?.payment_agreement_opt === SettingsValue.CUSTOM ||
          //   portalSettings?.payment_agreement_opt === SettingsValue.DEFAULT
          // ) {
          //   dispatch(onSetShowDisclosure(true));
          // handleClick()
          // } else {
          open();
          // }
        }}
        className="lg:w-40 !w-full"
        variant="variable"
      />
    );
  }
);

export default UpdateSchedulePayment;
